import {
  currentUserHasPermission,
  getThreadTypeMeta,
  checkUserRights,
  isPremium,
  FormatAmount,
  getLast36MonthsOptions,
  isLive,
  isTrial,
  isIOSDevice,
  getMyAgenciesMappedIDs,
  safeParseJsonArray,
  getTaskTitleForUser,
  getTaskPriorityForUser,
  extractObserverUserIDs,
} from "../../Utils/Utilities";
import React, { useEffect, useState } from "react";
import DashboardHeader from "./Fragments/DashboardHeader";
import { useSelector } from "react-redux";
import Leaderboard from "./Fragments/Leaderboard";
import ProductLeaderboard from "./Fragments/ProductLeaderboard";
import TaskEntry from "../Tasks/TaskEntry";
import ConnectionEntryDialog from "../Connections/ConnectionEntry";
import {
  checkIfInqOnlyMode,
  getActiveThreadTypesArr,
  getThreadTypesArr,
  userIsAdmin,
  getUsersArr,
} from "../../Store/Reducers";
import { addDays, differenceInHours, isAfter, isToday, isTomorrow, parseISO, getMonth, parse } from "date-fns";
import Tasks from "./Fragments/Tasks";
import GoalsDashboardCard from "./Fragments/GoalsDashboardCard";
import WebstoreSetupBanner from "./Fragments/WebstoreSetupBanner";
import AppDownloadBanner from "./Fragments/AppDownloadBanner";
import { SHOW_BUSINESS_GOALS } from "../../Utils/FeatureFlags";
import ThreadEntry from "../Threads/ThreadEntry";
import { useDesktop } from "../../Components/Common/IsDesktop";
import { Download, Plus, Puzzle, Settings, MoveDown, MoveDownIcon, ChevronDown, X, Phone, MessageCircle, Edit2, Check, SquareCheckBig, Calendar, GitFork, ShieldCheck, User, UserCheck, ArrowDown, ArrowUp, Clock, History, HelpCircle } from "lucide-react";
import ConnectionDetailsWrapper from "../Connections/ConnectionDetailsWrapper";
import { getAgencyData as getAgencyDataFromStorage } from "../../Utils/Storage";
// (kept aliased to avoid confusion with the local `agencyData` state/prop used throughout this file)
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose } from "../../Components/UI/dialog";
import { useRef } from "react";
import { AlertTriangle, Lightbulb, ArrowLeft, Trophy, MapPin, ChevronRight, ListTodo, Rocket, Target, Globe } from "lucide-react";
import TktDialog from "../Ticket/TktDialog";
import { Button } from "../../Components/UI/button";
import { getAuthData } from "../../Utils/AuthUtils";
import ContractEntry from "../Contracts/ContractEntry";
import UpgradeSubscription from "../Settings/UpgradeSubscription/UpgradeSubscription";
// import InquiryStats from "./Fragments/InquiryStats";
import { useNavigate, useLocation } from "react-router-dom";
import { useCurrency } from "../../Hooks/useCurrency";
import ThreadSahiIcon from "../../Components/Common/ThreadSahiIcon";
import { formatAmount } from "../../Utils/Utilities";
import { Crown } from "lucide-react";
import MastersDialog from "../Settings/Masters";
import ImpDialog from "../../Components/Common/ImpDialog";
import taskClassConfig from "../../Config/taskClassConfig.json";
import { getFromIndexedDB } from "../../Utils/IndexedDBUtils";
import { format } from "date-fns";
import IntgnConfig from "../Settings/SubSettings/IntgnConfig";
import Policies from "../Settings/Policies/Policies";
import MetaLeadImport from "../Threads/Integrations/MetaLeadImport";
import Upcoming from "../../Components/Common/Upcoming";
import useIsMobile from "../../Hooks/useIsMobile";
import PullToRefreshContainer from "../../Components/Common/PullToRefreshContainer";
import SummaryStats from "./Fragments/SummaryStats";
import QuickTraining from "../../Components/QuickTraining/QuickTraining";
import { getTrainingData } from "../../Components/QuickTraining/QuickTrainingData";
import NextAction from "./Fragments/NextAction";
import PricingFooter from "./Fragments/PricingFooter";
import RecordHistoryDialog from "../Connections/Tabs/RecordHistory";
import { MdPhone } from "react-icons/md";
import { BsWhatsapp } from "react-icons/bs";
import { getRecordsAPI } from "../Records/RecordAPI";
import GaugeComponent from 'react-gauge-component';
import { cn } from "../../Lib/Cn";
import { Label } from '../../Components/UI/label';
import { isSmartSellerMode } from "../../Store/Reducers";
import { Input } from '../../Components/UI/input';
import { Card, CardContent, CardHeader, CardTitle } from "../../Components/UI/card";
import { subMonths, getYear } from "date-fns";
import ApexCharts from 'apexcharts';
import { setUserTargetAPI } from "../Users/UsersAPI";
import { toast } from "sonner";
import BusinessInput from "../../Components/Common/BusinessInput";




const integrationData = [
  { id: 1, name: "indiaMart", image: isLive() ? "/Web/assets/Images/Integrations/indiamart.png" : "/assets/Images/Integrations/indiamart.png", alt: "Indiamart" },
  { id: 2, name: "justDial", image: isLive() ? "/Web/assets/Images/Integrations/justdial.png" : "/assets/Images/Integrations/justdial.png", alt: "Justdial" },
  { id: 3, name: "tradeIndia", image: isLive() ? "/Web/assets/Images/Integrations/tradeindia.png" : "/assets/Images/Integrations/tradeindia.png", alt: "TradeIndia" },
  { id: 4, name: "meta", image: isLive() ? "/Web/assets/Images/Integrations/meta.png" : "/assets/Images/Integrations/meta.png", alt: "Meta" },
  { id: 8, name: "w3", image: isLive() ? "/Web/assets/Images/Integrations/w3.png" : "/assets/Images/Integrations/w3.png", alt: "W3" },
];

// inside InqOpportunities (near top, after hooks)
const cssClasses = {
  actionBtn: "flex items-center gap-1 flex-none bg-sahi-disable hover:bg-sahi-blue-light text-sahi-primary-color hover:text-sahi-primary-color text-[11px] px-2 py-0.5 sm:text-sm sm:px-3 sm:py-2"
}

// Mobile OrdersMetrics Component - Only for mobile use
const MobileOrdersMetrics = ({ orderValues = 0, orderCounts = 0, conversion = 0, onAddOrder, onMetricClick }) => {
  const currencySymbol = useCurrency();
  const currMonth = format(new Date(), "MMM");
  const userRights = checkUserRights();
  const { data: agencyData } = useSelector(state => state.agencyData);

  return (
    <div className="overflow-hidden bg-sahi-white rounded-xl p-2 pt-0 pb-0">
      <div className="mb-4">
        <div className="p-2 pb-0 pt-0">
          <div className="flex items-center justify-between gap-2 mt-2 pb-2 ">
            <div className="flex items-center gap-2">
              {/* <ThreadSahiIcon tID={2} className="h-6 w-6" /> */}
              <span className="text-text-color text-xl sm:text-xl font-semibold">
                Sales <span className="text-base text-gray-500">({currMonth})</span>
              </span>
            </div>
            {userRights?.addThr &&
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onAddOrder && onAddOrder(2);
                }}
                className="p-1.5 rounded-md hover:bg-gray-100 transition-colors text-sahi-primary-color sahi-radius"
              >
                <Plus className="h-6 w-6" />
              </button>
            }
          </div>

          <div className="grid grid-cols-3 gap-2">

            <div onClick={onMetricClick} className="text-center rounded-lg flex flex-col items-center py-2.5 justify-center bg-sahi-disable border border-sahi-border-color break-words col-span-2">
              <div className="text-lg font-bold" style={{ color: "var(--sahi-green)" }}>
                <span className="text-xs text-sahi-grey mr-1">{currencySymbol}</span>
                {formatAmount(orderValues, agencyData.CountryID) || "0"}
                <span className="ml-2 text-[14px]" style={{ color: "var(--sahi-dark-blue)" }}>
                  ({orderCounts?.toLocaleString() || "0"})
                </span>
              </div>
              <div className="text-xs text-gray-600">Value (Count)</div>
            </div>

            {/* Conversion */}
            <div onClick={onMetricClick} className="text-center rounded-lg flex flex-col items-center py-2.5 justify-center bg-sahi-disable border border-sahi-border-color">
              <div className="text-lg font-bold" style={{ color: "var(--sahi-orange)" }}>
                {conversion}%
              </div>
              <div className="text-xs text-gray-600">Conversion</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


// Mobile Start Subscription Component - Only for mobile use
const MobileStartSubscription = ({ onUpgradeClick }) => {
  const isPremiumUser = isPremium();

  if (isPremiumUser) return null;

  return (
    <div className="flex flex-1 flex-col items-center gap-0">
      <Button
        onClick={onUpgradeClick}
        variant="sahiGreen"
        size="default"
        className="w-full gap-1"
      >
        <Crown className="h-4 w-4 mr-2" />
        <span>Buy Now</span>
      </Button>
    </div>
  );
};

// const OrderHistoryLeaderboard = ({

//   last3MonthsOrders = [],

//   currencySymbol,

//   countryID,

//   onThreadEntryOpen,

//   userRights

// }) => {

//   const navigate = useNavigate();



//   // Calculate total across the displayed 3 months for the header metric

//   const totalStats = last3MonthsOrders.reduce(

//     (acc, curr) => ({

//       value: acc.value + (curr.value || 0),

//       count: acc.count + (curr.count || 0),

//     }),

//     { value: 0, count: 0 }

//   );



//   return (

//     <Card className="flex flex-col overflow-hidden bg-sahi-white md:shadow-md !rounded-xl border-none shadow-sm gap-0">



//       {/* Desktop Header: Styled to match Leaderboard.js */}

//       <CardHeader className="sm:pb-1 sm:pt-0 pt-3 px-6 flex-shrink-0 hidden md:block md:mb-2">

//         <CardTitle className="flex items-center gap-2 text-lg justify-between">

//           <div

//             className="flex items-center gap-2 cursor-pointer group"

//             onClick={() => navigate(`/threads-report?tID=2&m=1`)}

//           >

//             <span className="text-text-color text-xl font-semibold group-hover:text-sahi-primary-color transition-colors">


//             </span>

//           </div>



//           <div className="flex items-center gap-3 ml-auto">

//             {/* Summary Metric in Header */}

//             <div className="text-right flex items-baseline gap-1">

//               <div className="text-xl font-bold text-sahi-dark-blue flex items-baseline gap-1">

//                 <span className="text-lg text-sahi-grey">{currencySymbol}</span>

//                 <FormatAmount amount={totalStats.value} countryID={countryID} showCurr={false} />

//                 <span className="text-base font-semibold text-sahi-grey">

//                   ({totalStats.count.toLocaleString()})

//                 </span>

//               </div>

//             </div>



//             {userRights?.addThr && (

//               <div

//                 className="p-1 text-sahi-primary-color hover:cursor-pointer hover:bg-sahi-blue-light sahi-radius duration-200"

//                 onClick={(e) => {

//                   e.stopPropagation();

//                   onThreadEntryOpen && onThreadEntryOpen(2);

//                 }}

//               >

//                 <Plus className="h-6 w-6" />

//               </div>

//             )}

//           </div>

//         </CardTitle>

//       </CardHeader>



//       {/* Mobile Header */}

//       <div className="md:hidden flex items-center justify-between p-3 px-4 pb-2">

//         <div className="flex items-center gap-2">

//           {/* <Trophy className="w-5 h-5 text-sahi-green" /> */}



//           <span className="text-text-color text-xl font-semibold">Ords</span>

//         </div>

//         <div className="flex items-center gap-2">

//           <div className="text-right flex items-baseline gap-1">

//             <div className="text-lg font-bold text-sahi-dark-blue flex items-baseline gap-1">

//               <span className="text-sm text-sahi-grey">{currencySymbol}</span>

//               <span className="text-base">{formatAmount(totalStats.value, countryID)}</span>

//               <span className="text-sm font-semibold text-sahi-grey">

//                 ({totalStats.count.toLocaleString()})

//               </span>

//             </div>

//           </div>

//           {userRights?.addThr && (

//             <button

//               onClick={() => onThreadEntryOpen && onThreadEntryOpen(2)}

//               className="p-1.5 rounded-lg text-sahi-primary-color"

//             >

//               <Plus className="h-6 w-6" />

//             </button>

//           )}

//         </div>

//       </div>



//       {/* Content Area: No fixed height, space-y-2 provides tight layout */}

//       <CardContent className="md:px-6 md:pb-6 px-3 pb-3 m-0">

//         <div className="space-y-2">

//           {last3MonthsOrders.map((monthData, index) => (

//             <div

//               key={index}

//               className="flex items-center justify-between md:p-3 p-3 rounded-lg bg-sahi-disable border border-sahi-border-color shadow-sm cursor-pointer hover:bg-gray-100 transition-all group"

//               onClick={() => navigate(`/threads-report?tID=2&m=${monthData.monthNumber}`)}

//             >

//               {/* Month Name */}

//               <div className="flex items-center min-w-0">

//                 <span className="font-bold text-sm md:text-[15px] ">

//                   {monthData.monthName}

//                 </span>

//               </div>



//               {/* Value and Count */}

//               <div className="text-right flex-shrink-0 ml-2">

//                 <div className="font-bold text-sm md:text-lg flex items-baseline justify-end gap-1 text-sahi-primary-color">

//                   <span className="text-sm text-sahi-grey">{currencySymbol}</span>

//                   <span className="leading-none text-sahi-green">

//                     {formatAmount(monthData.value, countryID)}

//                   </span>

//                   <span className="text-xs font-semibold text-sahi-dark-blue opacity-70">

//                     ({monthData.count?.toLocaleString() || "0"})

//                   </span>

//                 </div>

//               </div>

//             </div>

//           ))}

//         </div>

//       </CardContent>

//     </Card>

//   );

// };

// Mobile Details Pending Card Component
const MobileDetailsPendingCard = ({ callCount = 0, messageCount = 0, totalCount = 0, onCallsClick, onMessagesClick }) => {
  if (totalCount === 0) return null;

  const hasOnlyOneButton = (callCount > 0 ? 1 : 0) + (messageCount > 0 ? 1 : 0) === 1;

  return (
    <div className="overflow-hidden bg-sahi-white rounded-xl shadow-sm">
      <div className="flex items-center justify-between gap-2 p-3 px-4">
        <span className="text-text-color text-lg font-semibold">
          Interaction Details Pending
        </span>
        <span className="text-sahi-dark-blue font-bold text-lg">
          {totalCount}
        </span>
      </div>

      <div className={`px-4 pb-3 flex gap-2 ${callCount > 0 && messageCount > 0 ? 'w-full' : 'w-1/2'}`}>
        {callCount > 0 && (
          <Button
            size="sm"
            className={`h-auto py-2 px-2 text-xs bg-gray-100 border border-gray-200 text-foreground hover:bg-gray-200 ${hasOnlyOneButton ? '' : 'flex-1'} flex items-center justify-between`}
            onClick={onCallsClick}
          >
            <MdPhone className="h-4 w-4 text-black" />
            <span className="text-sm font-semibold">Calls <span className="text-gray-900">({callCount})</span></span>
            <Edit2 className="h-3 w-3 text-sahi-dark-blue flex-shrink-0" />
          </Button>
        )}
        {messageCount > 0 && (
          <Button
            size="sm"
            className={`h-auto py-2 px-2 text-xs bg-gray-100 border border-gray-200 text-foreground hover:bg-gray-200 ${hasOnlyOneButton ? '' : 'flex-1'} flex items-center justify-between`}
            onClick={onMessagesClick}
          >
            <BsWhatsapp className="h-4 w-4 text-black text-sahi-green" />
            <span className="text-sm font-semibold">Msgs <span className="text-gray-900">({messageCount})</span></span>
            <Edit2 className="h-3 w-3 text-sahi-dark-blue flex-shrink-0" />
          </Button>
        )}
      </div>
    </div>
  );
};

const DetailsPending = ({ callCount = 0, messageCount = 0, totalCount = 0, onCallsClick, onMessagesClick }) => {
  if (totalCount === 0) {
    return null;
  }

  const hasOnlyOneButton = (callCount > 0 ? 1 : 0) + (messageCount > 0 ? 1 : 0) === 1;

  return (
    <div className="w-full h-full">
      <div className="bg-bg-white rounded-xl md:shadow-md border-none shadow-none h-full flex flex-col p-2">
        <div className="flex items-center justify-between gap-2 pt-1 pl-3  pb-4 pr-6">
          <span className="text-text-color text-xl sm:text-xl font-semibold">
            Interaction Details Pending
          </span>
          <span className="text-sahi-dark-blue font-bold text-lg">
            {totalCount}
          </span>
        </div>

        <div className="flex-1 flex items-center px-3 pb-3">
          <div className="flex w-full gap-2">
            {callCount > 0 && (
              <div className={`flex items-center justify-between px-3 py-3 rounded-lg bg-sahi-disable border border-sahi-border-color cursor-pointer min-w-0 ${hasOnlyOneButton ? 'w-1/2' : 'flex-1'}`} onClick={onCallsClick}>
                <div className="flex items-center gap-2 min-w-0">
                  <MdPhone className="h-5 w-5 text-black flex-shrink-0" />
                  <span className="text-xs sm:text-[15px] font-semibold text-text-color whitespace-nowrap">Calls ({callCount})</span>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0 ml-1">
                  <Edit2 className="h-4 w-4 text-sahi-dark-blue flex-shrink-0" />
                </div>
              </div>
            )}

            {messageCount > 0 && (
              <div className={`flex items-center justify-between px-3 py-3 rounded-lg bg-sahi-disable border border-sahi-border-color cursor-pointer min-w-0 ${hasOnlyOneButton ? 'w-1/2' : 'flex-1'}`} onClick={onMessagesClick}>
                <div className="flex items-center gap-2 min-w-0">
                  <BsWhatsapp className="h-5 w-5 text-sahi-green flex-shrink-0" />
                  <span className="text-xs sm:text-[15px] font-semibold text-text-color whitespace-nowrap">Messages ({messageCount})</span>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0 ml-1">
                  <Edit2 className="h-4 w-4 text-sahi-dark-blue flex-shrink-0" />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};


const InqOpportunities = ({ businessActivities = [], threadData = [], onThreadEntryOpen, onThreadStagesModalOpen, onImportDialogOpen, isAdmin, userRights }) => {
  const navigate = useNavigate();
  const currencySymbol = useCurrency();
  const isMobile = useIsMobile();
  const { data: agencyData } = useSelector(state => state.agencyData);

  const threadStages = useSelector(
    (state) => state.masterData?.threadStages || []
  );

  // Only Sales Inquiry (id === 1)
  const filteredActivities = businessActivities.filter(
    (activity) => activity && activity.id === 1
  );

  const stageColors = ["#062f12", "#094418", "#0b5d1e", "#107a28", "#17a53b"];
  const getStageColor = (stageIndex) =>
    stageColors[stageIndex] || stageColors[stageColors.length - 1];

  const mapStageData = (threads) => {
    const map = {};
    threads.forEach((thread) => {
      const sid = thread.CurrStageID;
      if (!map[sid]) map[sid] = { count: 0, value: 0 };
      map[sid].count += 1;
      map[sid].value += parseFloat(thread.BizProspect || 0);
    });
    return map;
  };

  const getActivityDetails = (activity) => {
    const entry = threadStages.find((t) => Number(t.TID) === activity.id);
    const stages = entry?.Stages || [];
    const configuredStages = stages.map((stage, index) => ({
      id: stage.SID,
      name: stage.S,
      stageIndex: index,
      color: getStageColor(index),
    }));

    // Get stage-wise counts and values for active threads of this activity
    const threadsForType = threadData.filter(
      (thread) => thread.TypeID === activity.id && thread.StatusID !== 3
    );

    const countsMap = mapStageData(threadsForType);
    const stagesWithCounts = configuredStages.map((stage) => {
      const entry = countsMap[stage.id] || { count: 0, value: 0 };
      return { ...stage, count: entry.count, value: entry.value };
    });
    return { stages: stagesWithCounts };
  };

  if (filteredActivities.length === 0) return null;

  // Funnel Geometry
  const calcStageWidth = (index, slantPercent, minPercent) => {
    const slantFactor = slantPercent / 100;
    const width = 100 * Math.pow(slantFactor, index);
    return Math.max(minPercent, Number(width.toFixed(2)));
  };

  const slantPer = 99; //how much to slant the stage
  const minStagePer = 28; //for last stage
  const numOffsetPer = 4; //to move amount either left or right

  // Common Text Shadow for all
  const textShadowStyle = {
    textShadow: "0 1px 3px rgba(0,0,0,0.4)",
  };

  return (
    <div className={`bg-bg-white rounded-xl py-4 ${isMobile ? 'px-1' : 'px-3'} pt-0 pb-1 md:border md:border-sahi-border-color md:shadow-md border-none shadow-none text-center`}>
      {userRights.canSeeCstrs && (
        <div className="text-2xl p-1 font-semibold flex-shrink-0 flex items-center justify-between border-sahi-border-color text-text-color"></div>
      )}
      <div>
        {filteredActivities.map((activity) => {
          const details = getActivityDetails(activity);
          const hasStages = details.stages && details.stages.length > 0;
          const totalStages = details.stages.length;
          const lastIndex = Math.max(0, totalStages - 1);
          const lastStageWidth = calcStageWidth(lastIndex, slantPer, minStagePer);
          const anchorLeftPercent = Math.max(0, lastStageWidth - numOffsetPer);

          return (
            <div key={activity.id} className={`${isMobile ? 'mb-2' : 'mb-4'}`}>
              <div className="p-2 pb-0 pt-0">
                <div className="flex items-center justify-between mb-3">
                  <div
                    className="flex items-center gap-2 cursor-pointer"
                    onClick={() => navigate(`/threads?tid=${activity.id}`)}
                  >
                    {/* <ThreadSahiIcon tID={activity.id} className="h-6 w-6" /> */}
                    <span className="text-text-color text-lg sm:text-xl font-semibold">
                      {/* {activity.name} */}
                      Inquiries
                    </span>
                  </div>

                  {/* Action Icons - Top Right */}
                  <div className="flex items-center gap-1">
                    {userRights?.addThr && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          onThreadEntryOpen && onThreadEntryOpen(1);
                        }}
                        className="p-1.5  hover:bg-gray-100 transition-colors text-sahi-primary-color sahi-radius"
                        data-tour="inq-signup-actiontime"
                      >
                        <Plus className="h-5 w-5" />
                      </button>
                    )}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onThreadStagesModalOpen && onThreadStagesModalOpen(true);
                      }}
                      className="p-1.5  hover:bg-gray-100 transition-colors text-sahi-primary-color sahi-radius"
                    >
                      <Settings className="h-5 w-5" />
                    </button>
                  </div>
                </div>

                {hasStages && (
                  <div className="mb-2 overflow-visible">
                    <div className="flex flex-col gap-3 overflow-visible items-start">
                      {(() => {
                        const allAmountsAreZero = details.stages.every(stage => !stage.value || stage.value === 0);

                        return details.stages.map((stage, idx) => {
                          const widthPercent = calcStageWidth(
                            idx,
                            slantPer,
                            minStagePer
                          );
                          const funnelClipPath = `polygon(0 0, 100% 0, ${slantPer}% 100%, 0 100%)`;
                          return (
                            <div
                              key={stage.stageIndex}
                              className="text-left w-full relative flex"
                            >
                              {/* Funnel */}
                              <button
                                onClick={() =>
                                  navigate(
                                    `/threads?tid=${activity.id}&stg=${stage.stageIndex + 1
                                    }`
                                  )
                                }
                                className={`relative px-3 sm:px-4 py-2 transition-all text-white flex items-center shadow-md ${isMobile ? 'h-[45px]' : 'h-[55px]'} `}
                                style={{
                                  ...textShadowStyle,
                                  backgroundColor: stage.color,
                                  width: `${widthPercent}%`,
                                  clipPath: funnelClipPath,
                                  WebkitClipPath: funnelClipPath,
                                  borderRadius: "6px 0 0 6px",
                                  border: "1px solid rgba(0,0,0,0.06)",
                                }}
                              >
                                <div className="flex items-center gap-3 sm:gap-4 w-full">
                                  <div className="flex-shrink-0 min-w-[70px] sm:min-w-[100px] text-left max-w-[220px] truncate">
                                    <span
                                      className={`font-semibold  sm:text-[18px] truncate ${isMobile ? 'text-sm' : 'text-base'}`}
                                      style={textShadowStyle}
                                    >
                                      {stage.name}
                                    </span>
                                  </div>
                                </div>
                              </button>

                              <div style={{ position: "absolute", top: "50%", transform: "translate(-100%, -50%)", left: `${anchorLeftPercent}%`, zIndex: 20, whiteSpace: "nowrap", pointerEvents: "none", }} aria-hidden>
                                <div
                                  className="flex items-baseline gap-1 sm:gap-1 justify-end text-white text-xs sm:text-sm"
                                  style={textShadowStyle}
                                >
                                  {allAmountsAreZero ? (
                                    <span className="font-semibold text-white text-sm sm:text-base">
                                      {stage.count?.toLocaleString
                                        ? stage.count.toLocaleString()
                                        : "0"}
                                    </span>
                                  ) : (
                                    <>
                                      <span className="font-semibold flex items-baseline">
                                        <span className="text-sm sm:text-base mr-1">
                                          {currencySymbol}
                                        </span>
                                        <span className="text-sm sm:text-base tracking-wide">
                                          {!isMobile ? <FormatAmount amount={stage.value} showCurr={false} showZero={true} /> :
                                            formatAmount(stage.value, agencyData.CountryID)
                                          }
                                        </span>
                                      </span>
                                      <span>
                                        (
                                        {stage.count?.toLocaleString
                                          ? stage.count.toLocaleString()
                                          : "0"}
                                        )
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        });
                      })()}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}

        {/* Action buttons - left aligned at bottom */}
        {/* <div className="px-2 pb-2">
          <div className="flex gap-2 flex-wrap items-center">
            {userRights?.addThr && (
              <Button
                variant="outline"
                className={cssClasses.actionBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  onThreadEntryOpen && onThreadEntryOpen(1);
                }}
              >
                <Plus className="h-4 w-4" />
                Enter Inquiry
              </Button>
            )}

            {isAdmin &&
              <Button
                variant="outline"
                className={cssClasses.actionBtn}
                onClick={() => {
                  navigate('/settings#integrations');
                }}
              >
                <Puzzle className="h-4 w-4" />
                Integrations
              </Button>
            }
            {(userRights?.addThr || userRights?.addConns) &&
              <Button
                variant="outline"
                className={cssClasses.actionBtn}
                onClick={() => onImportDialogOpen && onImportDialogOpen(true)}
              >
                <Download className="h-4 w-4" />
                Import
              </Button>
            }
          </div>
        </div> */}
      </div>
    </div>
  );
};



const SHOW_TASKS_QUICK_ACCESS = true;
const SHOW_QUICK_ACTIONS = true;

const InqDashboard = () => {
  // Local state variables
  const [isInitialized, setIsInitialized] = useState(false);
  const isMobile = useIsMobile();
  const [isTaskEntryOpen, setIsTaskEntryOpen] = useState(false);
  const [taskEntryPrefillData, setTaskEntryPrefillData] = useState(null);
  const [activeMobileTab, setActiveMobileTab] = useState('Growth');

  useEffect(() => {
    // Small delay to ensure the hook has properly initialized
    const timer = setTimeout(() => {
      setIsInitialized(true);
    }, 10);

    return () => clearTimeout(timer);
  }, []);
  // Integration Dialog States
  const [upcomingOpen, setUpcomingOpen] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configIntegration, setConfigIntegration] = useState({ name: "", isWeb: false });
  const [policyOpen, setPolicyOpen] = useState(false);
  const [policyType, setPolicyType] = useState("");
  const [metaImportOpen, setMetaImportOpen] = useState(false);
  const isInqOnly = useSelector(checkIfInqOnlyMode);
  const isInqOnlyMode = useSelector(checkIfInqOnlyMode);
  const isPremiumUser = isPremium();

  const handleIntgnClick = (card) => {
    // Handle Policy types (Email & Google Review)
    if (card.type === "policy" || card.name === "email" || card.name === "googleReview") {
      if (card.name === "email") {
        setPolicyType("EMAIL");
      } else if (card.name === "googleReview") {
        setPolicyType("GOOGLE_REVIEW_LINK");
      }
      setPolicyOpen(true);
    }
    else if (card.name === "meta") {
      setMetaImportOpen(true);
    }
    else if ([5, 6, 7, 8].includes(card.id)) {
      setUpcomingOpen(true);
    }
    else {
      setConfigIntegration({ name: card.name, isWeb: false });
      setConfigOpen(true);
    }
  };
  const [upgradeOpen, setIsUpgradeOpen] = useState(false);
  const [isConnectionEntryOpen, setIsConnectionEntryOpen] = useState(false);
  const [isThreadStagesModalOpen, setIsThreadStagesModalOpen] = useState(false);
  const [trialMessage, setTrialMessage] = useState("");
  const [showTrialMessage, setShowTrialMessage] = useState(false);
  const navigate = useNavigate();
  const currencySymbol = useCurrency();
  let nowDT = new Date();
  const currMonthNumber = nowDT.getMonth() + 1;
  const currMonth = format(nowDT, "MMM");

  const [isThreadEntryOpen, setIsThreadEntryOpen] = useState(false);
  const [dashboardHeaderData, setDashboardHeaderData] = useState({
    agencyID: null,
    agencyName: "",
    metrics: [],
  });
  const [currentConnType, setCurrentConnType] = useState("");
  const [businessActivities, setBusinessActivities] = useState([]);
  const [currentThreadTypeID, setCurrentThreadTypeID] = useState("");
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [tasksData, setTasksData] = useState({
    todayTasks: [],
    overdueTasks: [],
    thisWeekTasks: [],
  });
  const [selectedConnection, setSelectedConnection] = useState(null);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [selectedFeedbackType, setSelectedFeedbackType] = useState(null);
  const authData = getAuthData();
  const currentUserID = authData?.UserID;
  const [isContractEntryOpen, setIsContractEntryOpen] = useState(false);
  const [currentContractType, setCurrentContractType] = useState("");
  const [inactiveDialogOpen, setInactiveDialogOpen] = useState(false);
  const [recordHistoryOpen, setRecordHistoryOpen] = useState(false);
  const [recordHistoryFilter, setRecordHistoryFilter] = useState(null);
  const [pendingRecordsData, setPendingRecordsData] = useState([]);
  const [detailsPendingRecords, setDetailsPendingRecords] = useState([]);
  const inactiveSectionRef = useRef(null);
  const tasksSectionRef = useRef(null); // Ref for Tasks section
  const location = useLocation(); // To access query params
  const threadStages = useSelector(
    (state) => state.masterData?.threadStages || []
  );
  const userData = useSelector(getUsersArr);
  const isSupervisor = userData.some(u => u.SupervisorID === Number(currentUserID));
  // Get list of UserIDs that this supervisor manages
  const managedUserIDs = isSupervisor
    ? userData.filter(u => u.SupervisorID === Number(currentUserID)).map(u => u.UserID)
    : [];

  const { data: activeData } = useSelector((state) => state.activeData);
  const loggedInUserInfo = userData.find(
    (u) => u.UserID === Number(currentUserID)
  );

  // Inside InqDashboard component
  const computeTarget = () => {
    const MM = nowDT.getMonth() + 1, YY = nowDT.getFullYear();
    const monthlyThreads = JSON.parse(activeData?.MonthlyThreads || "[]");

    const orderThread = monthlyThreads.find(
      (thread) => thread.MM === MM && thread.YY === YY && thread.TID === 2
    );

    if (orderThread && orderThread.Usrs) {
      const users = safeParseJsonArray(orderThread.Usrs);
      const userTarget = users.find((user) => user.UID === loggedInUserInfo?.UserID);

      if (userTarget && (userTarget.TA > 0 || userTarget.TC > 0)) {
        const targetType = userTarget?.TM === 2 ? 'amount' : 'count';
        const targetValue = userTarget?.TM === 2 ? userTarget?.TA : userTarget?.TC;

        return {
          type: targetType || 'amount',
          value: targetValue || 0
        };
      }
    }

    // Fallback: Search for the latest (most recent) previous month's target that was set
    const prevThreads = monthlyThreads
      .filter((thread) => thread.TID === 2 && !(thread.YY === YY && thread.MM === MM))
      .sort((a, b) => {
        if (a.YY !== b.YY) return b.YY - a.YY;
        return b.MM - a.MM;
      });

    for (const thread of prevThreads) {
      if (thread.Usrs) {
        const users = safeParseJsonArray(thread.Usrs);
        const userTarget = users.find((user) => user.UID === loggedInUserInfo?.UserID);
        if (userTarget && (userTarget.TA > 0 || userTarget.TC > 0)) {
          const targetType = userTarget?.TM === 2 ? 'amount' : 'count';
          const targetValue = userTarget?.TM === 2 ? userTarget?.TA : userTarget?.TC;
          return {
            type: targetType || 'amount',
            value: targetValue || 0
          };
        }
      }
    }

    // Default if no data found
    return { value: 0, type: 'amount' };
  };

  const [target, setTarget] = useState(computeTarget);

  // Recompute the target whenever the active agency's data changes (e.g. after an agency
  // switch) - a useState lazy initializer only runs once on mount, so without this the
  // tracker would keep showing the previous agency's target/amount until a hard refresh.
  useEffect(() => {
    setTarget(computeTarget());
  }, [activeData?.MonthlyThreads, loggedInUserInfo?.UserID, currentUserID]);

  const isAmtMode = target.type === 'amount';

  const isTodayOrYesterday = (dateString) => {
    if (!dateString) return false;
    const recordDate = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const recordDay = recordDate.toDateString();
    const todayDay = today.toDateString();
    const yesterdayDay = yesterday.toDateString();

    return recordDay === todayDay || recordDay === yesterdayDay;
  };

  const { data: agencyData } = useSelector((state) => state.agencyData);
  const cntMaxUsers = agencyData?.CntMaxUsers
  const { data: threadData } = useSelector((state) => state.threadData);
  const { data: taskData } = useSelector((state) => state.taskData);
  const { data: connectionData } = useSelector((state) => state.connectionData);
  const allThreadTypes = useSelector(getThreadTypesArr);

  // Scroll to tasks if ?tsk=1 is present
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("tsk") === "1" && tasksSectionRef.current) {
      setTimeout(() => {
        tasksSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300); // Small delay to ensure rendering
    }
  }, [location.search]);
  const [selectedMonth, setSelectedMonth] = useState(`${currMonth} ${nowDT.getFullYear()}`);
  const [monthlyExpenseData, setMonthlyExpenseData] = useState({
    awarenessCost: 0,
    newConversionsCost: 0,
    repeatBusinessCost: 0,
    deliveryCost: 0,
    totalMonthlyCustomersCount: 0,
    orderValues: 0,
    orderCounts: 0,
    conversion: 0
  });
  const [allConnsFromDB, setAllConnsFromDB] = useState([]);

  const handleMonthChange = (newMonth) => {
    setSelectedMonth(newMonth);
    const data = getSummaryStatsData(newMonth);
    setMonthlyExpenseData(data);
  };

  // Parse pending records from activeData and calculate stats
  const calculatePendingRecordsStats = () => {
    let callCount = 0;
    let messageCount = 0;

    try {
      const pendingData = JSON.parse(activeData?.PendingRecords || '[]');

      // Find the current user's pending records
      const userPendingData = Array.isArray(pendingData)
        ? pendingData.find(item => item.UID === Number(currentUserID))
        : null;

      if (userPendingData && Array.isArray(userPendingData.PndgRecs)) {
        // Filter to only include records from today or yesterday
        const filteredRecords = userPendingData.PndgRecs.filter(record =>
          isTodayOrYesterday(record.DT)
        );

        // Count messages and calls
        filteredRecords.forEach(record => {
          if (record.Typ === 'Message') {
            messageCount += record.Cnt || 0;
          } else if (record.Typ === 'Call') {
            callCount += record.Cnt || 0;
          }
        });
      }
    } catch (error) {
      console.error('Error parsing pending records:', error);
    }

    return { callCount, messageCount, total: callCount + messageCount };
  };

  // Update detailsPendingRecords when activeData changes
  useEffect(() => {
    const pendingData = JSON.parse(activeData?.PendingRecords || '[]');
    const tempDetailsPendingRecords = [];

    // Find the current user's pending records
    const userPendingData = Array.isArray(pendingData)
      ? pendingData.find(item => item.UID === Number(currentUserID))
      : null;

    // Filter to only include records from today or yesterday
    const filteredRecords = userPendingData && Array.isArray(userPendingData.PndgRecs)
      ? userPendingData.PndgRecs.filter(record => isTodayOrYesterday(record.DT))
      : [];

    if (Array.isArray(filteredRecords) && filteredRecords.length > 0) {
      const aggregated = filteredRecords.reduce((acc, item) => {
        if (item.Typ === 'Call') {
          acc.callCount += item.Cnt || 0;
          acc.callRIDs.push(...(item.RIDs ? item.RIDs.split(',').map(r => r.trim()) : []));
        } else if (item.Typ === 'Message') {
          acc.messageCount += item.Cnt || 0;
          acc.messageRIDs.push(...(item.RIDs ? item.RIDs.split(',').map(r => r.trim()) : []));
        }
        return acc;
      }, { callCount: 0, messageCount: 0, callRIDs: [], messageRIDs: [] });

      tempDetailsPendingRecords.push(
        { Typ: 'Call', Count: aggregated.callCount, RIDs: aggregated.callRIDs },
        { Typ: 'Message', Count: aggregated.messageCount, RIDs: aggregated.messageRIDs }
      );
    }

    setDetailsPendingRecords(tempDetailsPendingRecords);
  }, [activeData]);

  // Helper to safely parse JSON array fields coming from the API (mirrors Connections.jsx)
  const safeParseArray = (input, fallback = []) => {
    if (Array.isArray(input)) return input;
    try {
      return JSON.parse(input || "[]");
    } catch {
      return fallback;
    }
  };

  // Logic to match Connections.jsx contactCategory === 'InactiveCustomer' + noActivity filters exactly
  const getInactiveBreakdown = () => {
    const now = new Date();
    // Time boundaries
    const date30 = addDays(now, -30);
    const date60 = addDays(now, -60);
    const date90 = addDays(now, -90);

    const allowedTIDs = [2, 3];
    const allowedXns = [1, 3, 5];

    let countActive = 0;
    let count30 = 0;
    let count90 = 0;
    let countUnknown = 0;
    let totalCustomerActivity = 0;

    connectionData.forEach(conn => {
      // 1. Exclude Cold Contacts (matches Connections.jsx global cold exclusion)
      if (conn.IsCold === 1 || conn.IsCold === true) return;

      // 2. Must be a Customer (matches Connections.jsx connTypes.includes('C'))
      if (!conn.ConnType || !conn.ConnType.includes('C')) return;

      totalCustomerActivity++;

      const lastThread = conn.LastThreadDT ? new Date(conn.LastThreadDT) : null;
      const latestActivity = lastThread;

      // Mutually exclusive bucketing:
      // Unknown: null/undefined date
      // Active: 0 - 30 days only
      // 30+ Days: 30 - 90 days only
      // 90+ Days: 90+ days only
      if (!latestActivity) {
        countUnknown++;
      } else if (latestActivity >= date30) {
        countActive++;
      } else if (latestActivity >= date90) {
        count30++;
      } else {
        count90++;
      }
    });

    return { countActive, count30, count90, countUnknown, total: totalCustomerActivity };
  };

  const handlePendingRecordsClick = async (type) => {
    try {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;

      const records = await getRecordsAPI({
        recTypeID: 1,
        prdType: 'MM',
        prdQty: 2,
        year,
        month
      });

      const pendingRecord = detailsPendingRecords.find(item => item.Typ === type);
      const relevantRIDs = pendingRecord?.RIDs || [];

      const transformedRecords = records
        .filter(record => relevantRIDs.includes(record.RecordID?.toString()))
        .filter(record => isTodayOrYesterday(record.RecDT))
        .map(record => ({
          RID: record.RecordID,
          Typ: record.RecType || record.Typ,
          Txt: record.Record,
          DT: record.RecDT,
          UID: record.RecUserID,
          ConnID: record.ConnID,
          Loc: record.Loc,
          TIDs: record.ThreadIDs,
          RefTaskID: record.RefTaskID,
          IsInxn: record.IsInxn,
          RecTypeID: record.RecTypeID
        }));

      setPendingRecordsData(transformedRecords);
      setRecordHistoryFilter(type);
      setRecordHistoryOpen(true);
    } catch (error) {
      console.error('Error fetching pending records:', error);
    }
  };

  const handleRefreshPendingRecords = async () => {
    try {
      // Only refresh if a filter type is selected
      if (!recordHistoryFilter) return;

      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;

      const records = await getRecordsAPI({
        recTypeID: 1,
        prdType: 'MM',
        prdQty: 2,
        year,
        month
      });

      // Recalculate pending records stats from current activeData to get latest RIDs
      // This ensures edits that changed date/type are properly removed
      const pendingData = JSON.parse(activeData?.PendingRecords || '[]');
      let relevantRIDs = [];

      const userPendingData = Array.isArray(pendingData)
        ? pendingData.find(item => item.UID === Number(currentUserID))
        : null;

      if (userPendingData && Array.isArray(userPendingData.PndgRecs)) {
        const pendingRecord = userPendingData.PndgRecs.find(item => item.Typ === recordHistoryFilter);
        if (pendingRecord?.RIDs) {
          relevantRIDs = pendingRecord.RIDs.split(',').map(r => r.trim());
        }
      }

      const transformedRecords = records
        .filter(record => relevantRIDs.includes(record.RecordID?.toString()))
        .filter(record => isTodayOrYesterday(record.RecDT))
        .filter(record => {
          const recordText = record.Record || '';
          const isPendingCall = record.RecType === 'Call' && recordText.toLowerCase() === 'dialed call.';
          const isPendingMessage = record.RecType === 'Message' && recordText.toLowerCase() === 'sent message.';
          return isPendingCall || isPendingMessage;
        })
        .map(record => ({
          RID: record.RecordID,
          Typ: record.RecType || record.Typ,
          Txt: record.Record,
          DT: record.RecDT,
          UID: record.RecUserID,
          ConnID: record.ConnID,
          Loc: record.Loc,
          TIDs: record.ThreadIDs,
          RefTaskID: record.RefTaskID,
          IsInxn: record.IsInxn,
          RecTypeID: record.RecTypeID
        }));

      setPendingRecordsData(transformedRecords);
    } catch (error) {
      console.error('Error refreshing pending records:', error);
    }
  };

  const inactiveStats = getInactiveBreakdown();
  const pendingRecordsStats = calculatePendingRecordsStats();

  const handleOrdersMetricClick = () => {
    navigate(`/threads-report?tID=2&m=${currMonthNumber}`);
  };
  // Function which will handle close connection details dialog
  const handleDetailClose = () => setIsDetailOpen(false);

  // Handle feedback dialog
  const handleFeedbackOpen = (type) => {
    setSelectedFeedbackType(type);
    setIsFeedbackOpen(true);
  };

  const handleMetricClick = (metricLabel) => {
    const normalizedLabel = metricLabel.toLowerCase();
    if (isSmartSellerMode()) {
      if (normalizedLabel.includes('hot')) {
        // Redirect to Threads filtered by Starred and assigned to the current user
        navigate(`/threads?star=1&uid=${currentUserID}`);
      } else if (normalizedLabel.includes('regular')) {
        // Redirect to Threads filtered by non-starred and assigned to the current user
        navigate(`/threads?star=0&uid=${currentUserID}`);
      } else if (normalizedLabel.includes('cold')) {
        // Cold Leads = Inactive Customers. Trigger the existing Inactive Dialog/Scroll
        if (inactiveStats.total <= 0) return;
        if (isMobile) {
          inactiveSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          setInactiveDialogOpen(true);
        }
      }
    }

    else {
      if (normalizedLabel.includes('prospect')) {
        navigate(`/connections?t=P`);
      } else if ((normalizedLabel.includes('regular') || normalizedLabel.includes('customer')) && !normalizedLabel.includes('inactive')) {
        navigate(`/connections?t=C&la=3`);
      } else if (normalizedLabel.includes('inactive') || normalizedLabel.includes('customer')) {
        // Prevent action if count is 0
        if (inactiveStats.total <= 0) return;

        if (isMobile) {
          // Scroll to section on Mobile
          if (inactiveSectionRef.current) {
            inactiveSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        } else {
          // Open Dialog on Desktop
          setInactiveDialogOpen(true);
        }
      }
      else if (normalizedLabel.includes('hot leads')) {
        navigate(`/threads?star=1`);
      } else if (normalizedLabel.includes('cold contacts')) {
        navigate(`/connections?cold=1`);
      } else {
        navigate(`/connections`);
      }
    }
  };

  const handleFeedbackClose = () => {
    setIsFeedbackOpen(false);
    setSelectedFeedbackType(null);
  };

  // Helper function to check if thread type should be shown based on Sh property
  const shouldShowThreadType = (tid) => {
    const threadType = threadTypes.find((t) => t.TID === tid);
    return threadType ? (tType) => tType.Sh != false : false;
  };

  const [importDialogOpen, setImportDialogOpen] = useState(false);
  const threadTypes = useSelector(getActiveThreadTypesArr);
  const isAdmin = useSelector(userIsAdmin);
  const isDesktop = useDesktop();

  const userRights = checkUserRights();
  const isOrderVisible = shouldShowThreadType(2);
  const isPricingVisible = !isPremium() && agencyData?.SubTypeID === 1 && agencyData?.SubTillDT && new Date(agencyData.SubTillDT) > new Date();

  useEffect(() => {
    const agnData = getAgencyDataFromStorage();

    if (agnData) {
      try {
        if (agnData?.SubTillDT) {
          const subTill = parseISO(agnData.SubTillDT);
          const currDT = new Date();
          if (differenceInHours(subTill, currDT) <= 6) {
            setShowTrialMessage(true);
          }

          if (isToday(subTill)) {
            setTrialMessage("Today");
          }
          else if (isTomorrow(subTill)) {
            setTrialMessage("Tomorrow");
          }
          else if (isAfter(currDT, subTill)) {
            setTrialMessage("Your trial has expired.")
          }
          else {
            setTrialMessage("");
          }
        }
      } catch (error) {
        console.error("Error Parsing Subscription Data");
      }
    }
  }, [])


  useEffect(() => {
    return () => {
      document.title = "SahiClub";
    };
  }, []);

  // Update task data when connection data is changed
  useEffect(() => {
    const loadAllConns = async () => {
      try {
        const conns = await getFromIndexedDB('Conns') || [];
        setAllConnsFromDB(conns);
      } catch (e) {
        console.error("Failed to load connections from DB in InqDashboard", e);
      }
    };
    loadAllConns();
  }, [connectionData]);

  useEffect(() => {
    setTasksData(getProcessedTasks(taskData, connectionData));
  }, [taskData, connectionData, allConnsFromDB]);

  // Update bussiness activity data when thread data is changed
  // (also recompute when the active agency/user/activeData changes, e.g. on an agency switch,
  // since getLeaderboardData/getDashboardHeaderData read those from closure)
  useEffect(() => {
    setLeaderboardData(getLeaderboardData());
    setDashboardHeaderData(getDashboardHeaderData());
    setBusinessActivities(
      transformThreadsToActivities(threadData, threadTypes)
    );
  }, [threadData, threadTypes, agencyData, activeData, userData]);

  useEffect(() => {
    const data = getSummaryStatsData(selectedMonth);
    setMonthlyExpenseData(data);
  }, [selectedMonth, activeData]);

  const calculateMetrics = () => {
    const metrics = [];
    const thirtyDaysAgo = addDays(new Date(), -30);

    // 1) Get Counts
    const starredLeadsCount = threadData.filter(thread =>
      thread.IsStar === true &&
      Number(thread.POCUserID) === Number(currentUserID) &&
      thread.StatusID === 0
    ).length;

    const totalMyActiveThreads = threadData.filter(thread =>
      Number(thread.POCUserID) === Number(currentUserID) &&
      thread.StatusID === 0
    ).length;

    const regularLeadsCount = Math.max(0, totalMyActiveThreads - starredLeadsCount);

    const inactiveContactsCount = connectionData.filter(conn => {
      if (conn.IsCold === 1 || conn.IsCold === true) return false;
      if (conn.ConnType && conn.ConnType.includes('P')) return false;
      if (conn.ConnType && conn.ConnType.includes('C')) {
        const lastThreadDT = conn.LastThreadDT ? new Date(conn.LastThreadDT) : null;
        if (lastThreadDT && lastThreadDT >= thirtyDaysAgo) return false;
      }
      const lastRecordDate = conn.LastRecDT ? new Date(conn.LastRecDT) : null;
      const hasOldLastRecord = !lastRecordDate || lastRecordDate < thirtyDaysAgo;
      const hasNoThreads = !threadData.some(thread => thread.ConnID === conn.ConnID);
      return hasOldLastRecord && hasNoThreads;
    }).length;

    // if (isMobile || isSmartSellerMode()) {
    // 1. HOT CARD
    metrics.push({
      label: `Hot ${starredLeadsCount === 1 ? "Lead" : "Leads"}`,
      labelM1: "Hot",
      labelM2: starredLeadsCount === 1 ? "Lead" : "Leads",
      value: starredLeadsCount.toString(),
      color: "var(--sahi-orange)",
      type: 'hot'
    });

    // 2. REGULAR CARD
    metrics.push({
      label: `Regular ${regularLeadsCount === 1 ? "Lead" : "Leads"}`,
      labelM1: "Regular",
      labelM2: regularLeadsCount === 1 ? "Lead" : "Leads",
      value: regularLeadsCount.toString(),
      color: "var(--sahi-green)",
      type: 'regular'
    });

    // 3. COLD CARD (Renamed to Contact/Contacts)
    metrics.push({
      label: `Cold ${coldContactsCount === 1 ? "Contact" : "Contacts"}`,
      labelM1: "Cold",
      labelM2: coldContactsCount === 1 ? "Contact" : "Contacts",
      value: coldContactsCount.toString(),
      color: "var(--sahi-dark-blue)",
      type: 'cold'
    });

    // }
    // else {
    //   // Fallback logic for Standard Mode
    //   const prospects = connectionData.filter(conn => {
    //     if (conn.IsCold === 1 || conn.IsCold === true) return false;
    //     return conn.ConnType && conn.ConnType.includes('P');
    //   }).length;
    //   metrics.push({
    //     label: `Future ${prospects === 1 ? "Prospect" : "Prospects"}`,
    //     labelM1: "Future",
    //     labelM2: prospects === 1 ? "Prospect" : "Prospects",
    //     value: prospects.toString(),
    //     color: "var(--sahi-orange)",
    //   });

    //   const existingCustomers = connectionData.filter(conn => {
    //     if (conn.IsCold === 1 || conn.IsCold === true) return false;
    //     if (!conn.ConnType || !conn.ConnType.includes('C')) return false;
    //     const lastThreadDT = conn.LastThreadDT ? new Date(conn.LastThreadDT) : null;
    //     return (lastThreadDT && lastThreadDT >= thirtyDaysAgo);
    //   }).length;

    //   metrics.push({
    //     label: `Regular ${existingCustomers === 1 ? "Customer" : "Customers"}`,
    //     labelM1: "Existing",
    //     labelM2: existingCustomers === 1 ? "Customer" : "Customers",
    //     value: existingCustomers.toString(),
    //     color: "var(--sahi-green)",
    //   });

    //   metrics.push({
    //     label: `Inactive ${inactiveContactsCount === 1 ? "Customer" : "Customers"}`,
    //     labelM1: "Inactive",
    //     labelM2: inactiveContactsCount === 1 ? "Customer" : "Customers",
    //     value: inactiveContactsCount.toString(),
    //     color: "var(--sahi-dark-blue)",
    //   });

    // }

    return metrics;
  }

  // Inside InqDashboard component
  const getDailyValuesForMonth = (monthOffset = 0) => {
    const date = subMonths(new Date(), monthOffset);
    const mm = getMonth(date) + 1;
    const yy = getYear(date);

    // Parse the actual daily data from activeData
    // Note: Assuming activeData.DailyThreads contains the daily breakdown
    // If not, we generate a trend based on the monthly total for now
    const monthlyThreads = JSON.parse(activeData?.MonthlyThreads || "[]");
    const thread = monthlyThreads.find(m => m.TID === 2 && m.MM === mm && m.YY === yy);
    const totalAmt = thread ? Math.abs(thread.Amt || 0) : 0;

    // Logic: If you have daily data in your API, use it. 
    // Otherwise, this mock generator creates a professional trend line for the chart
    const daysInMonth = new Date(yy, mm, 0).getDate();
    const dailyValues = Array.from({ length: daysInMonth }, (_, i) => {
      // Random distribution for a realistic look if specific daily data isn't available
      return Math.floor((totalAmt / daysInMonth) * (0.5 + Math.random()));
    });

    return {
      monthName: format(date, "MMMM"),
      dailyValues: dailyValues,
      dates: Array.from({ length: daysInMonth }, (_, i) => i + 1)
    };
  };

  const currentMonthTrend = getDailyValuesForMonth(0);
  const lastMonthTrend = getDailyValuesForMonth(1);

  const calculatePremiumMetrics = () => {
    let orderValues = 0, orderCounts = 0, inquiryCounts = 0, conversion = 0;
    const monthlyData = JSON.parse(activeData?.MonthlyThreads || "[]");

    // Get data for current month
    const orders = monthlyData.filter(m => m.TID === 2 && m.MM === currMonthNumber);
    const inquiries = monthlyData.filter(m => m.TID === 1 && m.MM === currMonthNumber);

    if (orders.length > 0) {
      if (isAdmin) {
        // ADMIN: Sum of all users in the agency
        orderValues = Math.abs(orders.reduce((sum, item) => sum + (item.Amt || 0), 0));
        orderCounts = Math.abs(orders.reduce((sum, item) => sum + (item.Rcvd || 0), 0));
        inquiryCounts = Math.abs(inquiries.reduce((sum, item) => sum + (item.Rcvd || 0), 0));
      }
      else if (isSupervisor) {
        // SUPERVISOR: Own values + Values of managed users
        const allOrderUsrs = safeParseJsonArray(orders[0]?.Usrs);
        const allInqUsrs = safeParseJsonArray(inquiries[0]?.Usrs);

        const relevantUIDs = [Number(currentUserID), ...managedUserIDs];

        allOrderUsrs.forEach(u => {
          if (relevantUIDs.includes(u.UID)) {
            orderValues += (u.RA || 0);
            orderCounts += (u.RC || 0);
          }
        });

        allInqUsrs.forEach(u => {
          if (relevantUIDs.includes(u.UID)) {
            inquiryCounts += (u.RC || 0);
          }
        });
      }
      else {
        // REGULAR USER: Only their own data
        const userOrders = safeParseJsonArray(orders[0]?.Usrs).find(u => u.UID === Number(currentUserID));
        const userInqs = safeParseJsonArray(inquiries[0]?.Usrs).find(u => u.UID === Number(currentUserID));
        orderValues = userOrders?.RA || 0;
        orderCounts = userOrders?.RC || 0;
        inquiryCounts = userInqs?.RC || 0;
      }
    }

    if (inquiryCounts > 0) conversion = Math.round((orderCounts / inquiryCounts) * 100);
    return { orderValues, orderCounts, conversion };
  };

  const calculateExpectedPipeline = () => {
    // 1. Get EVERY active Sales Inquiry thread for the whole agency
    // We do NOT filter by POCUserID here so the value is same for everyone
    const threadsForType = threadData.filter(t => t.TypeID === 1 && t.StatusID !== 3);

    // 2. Get the stages metadata (Probabilities)
    const stageMeta = threadStages.find(t => Number(t.TID) === 1)?.Stages || [];

    // 3. Calculate weighted value for the entire agency
    return stageMeta.reduce((sum, meta) => {
      // Get all threads currently in this specific stage
      const threadsInStage = threadsForType.filter(t => t.CurrStageID === meta.SID);

      if (threadsInStage.length === 0) return sum;

      // Calculate raw sum for this stage (Amount vs Count mode)
      const stageRawSum = threadsInStage.reduce((s, t) => {
        return s + (target.type === 'amount' ? parseFloat(t.BizProspect || 0) : 1);
      }, 0);

      // Apply the Global Closing Probability (meta.C) defined in Master Data
      const probability = meta.C || 0;
      const weightedStageValue = (stageRawSum * (probability / 100));
      return Math.round((sum + weightedStageValue));
    }, 0);

  };

  const premiumMetrics = calculatePremiumMetrics();

  const getHotLeadsCount = () => {
    return threadData.filter(t => t.IsStar === 1 || t.IsStar === true).length;
  };

  const getColdContactsCount = () => {
    return connectionData.filter(c => c.IsCold === 1 || c.IsCold === true).length;
  };

  const hotLeadsCount = getHotLeadsCount();
  const coldContactsCount = getColdContactsCount();

  // Usage inside getDashboardHeaderData
  const getDashboardHeaderData = () => {
    const logoPath = agencyData?.Logo;
    const metrics = calculateMetrics();

    const agencyName = agencyData?.AgencyName || "N/A";
    const agencyID = agencyData?.AgencyID || null;

    return {
      agencyID,
      agencyName,
      logoPath,
      metrics: metrics || [],
    };
  };

  // const calculateExpectedPipeline = () => {
  //   const salesInquiry = businessActivities.find(a => a && a.id === 1);
  //   if (!salesInquiry) return 0;

  //   // Re-map details to ensure we are using fresh threadData
  //   const threadsForType = threadData.filter(t => t.TypeID === 1 && t.StatusID !== 3);
  //   const stageMeta = threadStages.find(t => Number(t.TID) === 1)?.Stages || [];

  //   return stageMeta.reduce((sum, meta) => {
  //     // Filter threads currently in this specific stage
  //     const threadsInStage = threadsForType.filter(t => t.CurrStageID === meta.SID);

  //     // Calculate raw sum for this stage based on Target Mode
  //     const stageRawSum = threadsInStage.reduce((s, t) => {
  //       return s + (target.type === 'amount' ? parseFloat(t.BizProspect || 0) : 1);
  //     }, 0);

  //     // Apply probability (Use .P or .C based on your actual MasterData key)
  //     const probability =  meta.C || 0; 
  //     return sum + (stageRawSum * (probability / 100));
  //   }, 0);
  // };

  const expectedPipelineValue = calculateExpectedPipeline();



  // Function which will return data for bussiness activity table
  const transformThreadsToActivities = (threads, threadTypes) => {
    const today = new Date();

    return threadTypes.map((type) => {
      if (
        !(
          (userRights?.canSeeCstrs && type?.Flow === "In") ||
          (userRights?.canSeeSplrs && type?.Flow === "Out")
        )
      ) {
        return null;
      }
      const matchingThreads = threads.filter((t) => {
        if (t.TypeID !== type.TID) return false;
        const conn = connectionData.find(c => c.ConnID === t.ConnID);
        if (conn && (conn.IsCold === 1 || conn.IsCold === true)) return false;
        return true;
      });

      const openThreads = matchingThreads.filter((t) => t.StatusID === 0);
      const open = openThreads.length;

      const delayed = openThreads.filter((t) => {
        return t.DueDT && new Date(t.DueDT) < today;
      }).length;

      const totalBizProspect = openThreads.reduce(
        (sum, t) => sum + t.BizProspect,
        0
      );

      const meta = getThreadTypeMeta(type.TID, threadTypes);

      return {
        id: type.TID,
        name: meta.name,
        icon: meta.Icon,
        iconType: meta.isFontAwesome ? "fontawesome" : "react",
        color: meta.textColor,
        open,
        delayed,
        value: totalBizProspect.toLocaleString(),
      };
    });
  };

  // Function which will return data for leaderboard
  const getLeaderboardData = () => {
    if (!userData || userData.length === 0) return [];
    const monthlySOs = activeData?.MonthlyThreads;

    // Parse Usrs data if available
    let usrsOrders = [];
    let usrsInquiries = [];
    if (monthlySOs) {
      try {
        const monthlyData = JSON.parse(monthlySOs);
        const salesOrders = monthlyData
          .filter((m) => m.TID === 2 && m.MM === currMonthNumber)
          .sort((a, b) => a.YY - b.YY || a.MM - b.MM);

        const salesInquiries = monthlyData
          .filter((m) => m.TID === 1 && m.MM === currMonthNumber)
          .sort((a, b) => a.YY - b.YY || a.MM - b.MM);

        if (salesOrders.length > 0) {
          const lastOrder = salesOrders[salesOrders.length - 1];
          usrsOrders = safeParseJsonArray(lastOrder.Usrs);
        }

        if (salesInquiries.length > 0) {
          const lastInquiry = salesInquiries[salesInquiries.length - 1];
          usrsInquiries = safeParseJsonArray(lastInquiry.Usrs);
        }
      } catch {
        usrsOrders = [];
        usrsInquiries = [];
      }
    }
    // Create leaderboard with all users
    const leaderboard = userData.map((user) => {
      // Find user's performance data in usrs array
      const usrRcvdOrdStats = usrsOrders.find((u) => u.UID === user.UserID);
      const usrRcvdInqStats = usrsInquiries.find((u) => u.UID === user.UserID);
      return {
        id: user.UserID,
        name: user.Name || "-",
        price: usrRcvdOrdStats?.RA || 0,
        orders: usrRcvdOrdStats?.RC || 0,
        inquiries: usrRcvdInqStats?.RC || 0,
      };
    });

    const sortedUsers = leaderboard.sort((a, b) => {
      if (b.price !== a.price) {
        return b.price - a.price
      }
      if (b.orders !== a.orders) {
        return b.orders - a.orders;
      }
      return a.name.localeCompare(b.name);
    });

    const top5Users = sortedUsers.slice(0, 5);
    return top5Users;

    // Filter users with orders and sort by price descending, then by orders descending
    const usersWithOrders = leaderboard
      .filter((u) => u.price > 0 && u.orders > 0)
      .sort((a, b) => {
        if (b.price !== a.price) return b.price - a.price;
        return b.orders - a.orders;
      });

    // If no users have orders, show current user with 0 orders and 0 amount
    if (usersWithOrders.length === 0 && loggedInUserInfo) {
      return [
        {
          id: loggedInUserInfo.UserID,
          name: loggedInUserInfo.Name || "-",
          price: 0,
          orders: 0,
        },
      ];
    }

    return usersWithOrders;
  };

  const getSummaryStatsData = (month) => {
    const MM = parse(month, "MMM yyyy", new Date()).getMonth() + 1;
    const YY = parse(month, "MMM yyyy", new Date()).getFullYear();

    // Monthly Expenses
    const monthlyExpenses = JSON.parse(activeData?.MonthlyExpenses || "[]");
    const monthlyExpensesData = monthlyExpenses.filter(e => e.MM === MM && e.YY === YY);

    const getExpenseByType = (ctid) => {
      const expense = monthlyExpensesData.find(e => e.CTID === ctid);
      return expense?.C ?? 0;
    };

    // Monthly Connections (Customers)
    const monthlyConns = JSON.parse(activeData?.MonthlyConns || "[]");
    const monthlyConnsData = monthlyConns.find((conn) => conn.MM === MM && conn.YY === YY);
    const totalMonthlyCustomersCount = monthlyConnsData?.C ?? 0;

    const monthlyThreads = JSON.parse(activeData?.MonthlyThreads || "[]");
    const leadThread = monthlyThreads.find((thread) => thread.MM === MM && thread.YY === YY && thread.TID === 1);
    const orderThread = monthlyThreads.find((thread) => thread.MM === MM && thread.YY === YY && thread.TID === 2);
    const totalMonthlyLeads = leadThread?.Rcvd ?? 0;
    const premiumMetrics = calculatePremiumMetrics(month);

    return {
      awarenessCost: getExpenseByType(1),
      newConversionsCost: getExpenseByType(2),
      repeatBusinessCost: getExpenseByType(3),
      deliveryCost: getExpenseByType(4),
      totalMonthlyCustomersCount,
      totalMonthlyLeads,
      orderValues: premiumMetrics.orderValues,
      orderCounts: premiumMetrics.orderCounts,
      conversion: premiumMetrics.conversion
    };
  };

  // Function which give prossesed task data
  const getProcessedTasks = (taskData, connectionData) => {
    if (!Array.isArray(taskData))
      return { todayTasks: [], overdueTasks: [], thisWeekTasks: [] };

    // Filter tasks with Status 1 only, assigned to/created by current user or mapped agency users, or where user is an observer on meeting tasks
    const filteredTasks = taskData.filter((task) => {
      if (task.Status !== 1) return false;
      const myUserIDs = getMyAgenciesMappedIDs('UserID');
      const userIDsToCheck = myUserIDs.length > 0 ? myUserIDs : [Number(currentUserID)];
      const isAssignedToMe = userIDsToCheck.includes(Number(task.POCUserID));
      const isAssignedByMe = userIDsToCheck.includes(Number(task.CreatedUserID));
      const classId = Number(task.Class || task.class || task.taskClass || task.TaskClass || 1);
      const obsIDs = extractObserverUserIDs(task);
      const isObserver = obsIDs.some(id => userIDsToCheck.includes(Number(id)));
      return isAssignedToMe || isAssignedByMe || (classId === 2 && isObserver);
    });

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const endOfToday = new Date(today);
    endOfToday.setHours(23, 59, 59, 999);

    const endOfNext7Days = new Date(today);
    endOfNext7Days.setDate(endOfNext7Days.getDate() + 7);
    endOfNext7Days.setHours(23, 59, 59, 999);

    const todayTasks = [];
    const overdueTasks = [];
    const thisWeekTasks = [];

    filteredTasks.forEach((task) => {
      // Find connection data for this task
      let conn = connectionData.find((c) => c.ConnID === task.ConnID);
      if (!conn && allConnsFromDB.length > 0) {
        conn = allConnsFromDB.find(c => Number(c.ConnID || c.connID || 0) === Number(task.ConnID));
      }

      const taskDate = new Date(task.DueDT);
      const taskDateStart = new Date(taskDate);
      taskDateStart.setHours(0, 0, 0, 0);

      const taskObj = {
        TskID: task.TaskID,
        Ttl: getTaskTitleForUser(task, currentUserID),
        BizName: conn?.BizName || "",
        ContactName: conn?.ContactName || "",
        DT: task.DueDT,
        Pri: getTaskPriorityForUser(task, currentUserID),
        ConnID: task.ConnID,
        UID: task.POCUserID,
        Typ: task.TaskType || "",
        Txt: task.Description,
        Sts: task.Status,
        TIDs: task.ThreadIDs,
        CreatedUID: task.CreatedUserID,
        Mobile: task.CreatorMobile || task.creatorMobile || task.Mobile || task.mobile || task.Mob || task.mob || null,
        CreatedMobile: task.CreatorMobile || task.creatorMobile || task.CreatedMobile || task.Mobile || task.mobile || task.Mob || task.mob || null,
        POCMobile: task.POCMobile || task.pocMobile || task.Mobile || task.mobile || task.Mob || task.mob || null,
        CreatedCtgID: task.CreatedCtgID,
        POCCtgID: task.POCCtgID,
        AgencyID: task.AgencyID || conn?.AgencyID,
        CanComplete: task.CanComplete,
        RepeatAfter: task.RepeatAfter,
        RepeatDT: task.RepeatDT,
        Class: task.Class || task.class || task.TaskClass || task.taskClass || 1,
      };

      if (taskDateStart.getTime() === today.getTime()) {
        todayTasks.push(taskObj);
      } else if (taskDateStart < today) {
        overdueTasks.push(taskObj);
      } else if (taskDate > endOfToday && taskDate <= endOfNext7Days) {
        thisWeekTasks.push(taskObj);
      }
    });

    return {
      todayTasks,
      overdueTasks,
      thisWeekTasks,
    };
  };

  const getColdContactsWithTasksDueToday = (taskData, connectionData) => {
    if (!Array.isArray(taskData) || !Array.isArray(connectionData)) {
      return {
        dueTodayCount: 0,
        dueTodayContacts: [],
        allColdContactsWithTasks: []
      };
    }

    const coldContacts = connectionData.filter(conn => conn.IsCold === 1 || conn.IsCold === true);

    const coldContactsWithTasks = coldContacts.map(conn => {
      const connTasks = taskData.filter(task => task.ConnID === conn.ConnID && task.Status === 1);

      if (connTasks.length === 0) {
        return null;
      }

      const oldestTask = connTasks.reduce((oldest, current) => {
        const currentDate = new Date(current.DueDT);
        const oldestDate = new Date(oldest.DueDT);
        return currentDate < oldestDate ? current : oldest;
      });

      return {
        ConnID: conn.ConnID,
        BizName: conn.BizName || "",
        ContactName: conn.ContactName || "",
        Mobile: conn.Mobile || "",
        Email: conn.Email || "",
        CC: conn.CC || "",
        IsCold: conn.IsCold,
        OldestTaskDueDate: new Date(oldestTask.DueDT).toISOString(),
        OldestTaskDueDateObj: new Date(oldestTask.DueDT),
        OldestTaskTitle: oldestTask.Task || "",
        OldestTaskID: oldestTask.TaskID,
        TaskCount: connTasks.length,
        POCUserID: oldestTask.POCUserID,
        Priority: oldestTask.Priority || "Medium"
      };
    }).filter(item => item !== null);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endOfToday = new Date(today);
    endOfToday.setHours(23, 59, 59, 999);

    const dueTodayContacts = coldContactsWithTasks.filter(contact => {
      const dueDate = new Date(contact.OldestTaskDueDate);
      dueDate.setHours(0, 0, 0, 0);
      return dueDate.getTime() <= today.getTime();
    });

    const priorityOrder = { 'High': 0, 'Medium': 1, 'Low': 2 };
    dueTodayContacts.sort((a, b) => {
      const aPriority = priorityOrder[a.Priority] ?? 99;
      const bPriority = priorityOrder[b.Priority] ?? 99;
      return aPriority - bPriority;
    });

    return {
      dueTodayCount: dueTodayContacts.length,
      dueTodayContacts: dueTodayContacts,
      allColdContactsWithTasks: coldContactsWithTasks
    };
  };

  const coldContactsData = getColdContactsWithTasksDueToday(taskData, connectionData);

  const getOrdersForMonth = (date) => {
    const mm = getMonth(date) + 1;
    const yy = getYear(date);
    const monthlyThreads = JSON.parse(activeData?.MonthlyThreads || "[]");

    // Find all entries for Sales Ords (TID: 2) in this specific month/year
    const monthDataArr = monthlyThreads.filter(m => m.TID === 2 && m.MM === mm && m.YY === yy);

    let totalAmt = 0;
    let totalCount = 0;

    if (monthDataArr.length > 0) {
      if (isAdmin) {
        // ADMIN: Sum total across the entire agency
        totalAmt = Math.abs(monthDataArr.reduce((sum, item) => sum + (item.Amt || 0), 0));
        totalCount = Math.abs(monthDataArr.reduce((sum, item) => sum + (item.Rcvd || 0), 0));
      }
      else if (isSupervisor) {
        // SUPERVISOR: Sum of self + supervised users
        const allUsrs = safeParseJsonArray(monthDataArr[0]?.Usrs);
        const relevantUIDs = [Number(currentUserID), ...managedUserIDs];

        allUsrs.forEach(u => {
          if (relevantUIDs.includes(u.UID)) {
            totalAmt += (u.RA || 0);
            totalCount += (u.RC || 0);
          }
        });
      }
      else {
        // REGULAR USER: Only their own performance
        const allUsrs = safeParseJsonArray(monthDataArr[0]?.Usrs);
        const userStats = allUsrs.find(u => u.UID === Number(currentUserID));
        totalAmt = userStats?.RA || 0;
        totalCount = userStats?.RC || 0;
      }
    }

    return {
      monthName: format(date, "MMM yyyy"),
      monthNumber: mm,
      value: totalAmt,
      count: totalCount
    };
  };
  const last3MonthsOrders = [
    getOrdersForMonth(nowDT),           // Current Month (e.g., Jan)
    getOrdersForMonth(subMonths(nowDT, 1)), // Prev (e.g., Dec)
    getOrdersForMonth(subMonths(nowDT, 2))  // Prev-Prev (e.g., Nov)
  ];


  const getCombinedStats = (type) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return taskData?.filter(t => {
      const isMine = Number(t.POCUserID) === Number(currentUserID);
      const isOpen = t.Status === 1;
      const dueDT = new Date(t.DueDT);
      dueDT.setHours(0, 0, 0, 0);

      const isTodayOrOverdue = dueDT <= today;
      if (!isMine || !isOpen || !isTodayOrOverdue) return false;

      // Corrected Type Logic
      const taskType = t.TaskType?.trim(); // Handle potential whitespace
      if (type === "Call") return taskType === "Call";
      if (type === "Message") return taskType === "Message";

      // "Other" logic: If it's NOT a call and NOT a message, it counts as Other
      if (type === "Other") {
        return taskType !== "Call" && taskType !== "Message";
      }

      return false;
    }).length || 0;
  };

  const taskTimeCategories = [
    { label: "Overdue", count: tasksData.overdueTasks.length, color: "var(--sahi-red)", period: "overdue" },
    { label: "Today", count: tasksData.todayTasks.length, color: "var(--sahi-dark-blue)", period: "today" },
    { label: "Week Ahead", count: tasksData.thisWeekTasks.length, color: "var(--sahi-green)", period: "week" },
  ];

  const MobileActionCenter = ({
    pendingRecordsStats,
    onCallsClick,
    onMessagesClick,
    tasksCount,
    onTasksClick
  }) => {
    const hasDetailsPending = pendingRecordsStats.total > 0;
    const hasTaskPending = tasksData.todayTasks.length > 0 || tasksData.overdueTasks.length > 0;

    // Logic to check if only one type of action is available
    const showCall = pendingRecordsStats.callCount > 0;
    const showMsg = pendingRecordsStats.messageCount > 0;
    const isSingleButton = (showCall ? 1 : 0) + (showMsg ? 1 : 0) === 1;

    return (
      <div className="mx-4 overflow-hidden bg-sahi-white rounded-xl border-sahi-border-color">
        {/* Interaction Details Section */}


        {/* Pending Tasks Section */}
        {/* {hasTaskPending &&
          <div className="p-4 cursor-pointer" onClick={() => navigate('/tasks')}>
            <div className="flex items-center justify-between mb-3">
              <span className="text-text-color text-lg font-semibold">Pending Tasks</span>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleTaskEntryOpen();
                }}
                className="p-1 hover:bg-gray-100 rounded text-sahi-primary-color sahi-radius"
              >
                <Plus className="h-5 w-5" />
              </button>
            </div>
            <div className="grid grid-cols-3 gap-2">
              {tasksCount.map((cat, idx) => (
                <div
                  key={idx}
                  onClick={(e) => {
                    e.stopPropagation();
                    onTasksClick(cat.period);
                  }}
                  className="bg-sahi-disable border border-sahi-border-color sahi-radius py-2 flex flex-col items-center justify-center active:bg-gray-200"
                >
                  <span className="text-xl font-bold" style={{ color: cat.color }}>{cat.count}</span>
                  <span className="text-[10px]  font-bold text-gray-500">{cat.label}</span>
                </div>
              ))}
            </div>
          </div>
        } */}
        {hasDetailsPending && (
          <div className="p-3 pt-3.5 pb-3.5 border-b border-gray-100">
            <div className="flex items-center justify-between mb-3 h-6">
              <span className="text-text-color text-lg font-semibold">
                Details Pending <span className="text-sahi-dark-blue ml-1">({pendingRecordsStats.total})</span>
              </span>     </div>
            <div className="flex gap-2">
              {showCall && (
                <Button
                  size="sm"
                  className={`${isSingleButton ? 'w-1/2' : 'flex-1'} h-10 border border-sahi-border-color bg-sahi-disable sahi-radius text-foreground hover:bg-gray-200 flex items-center justify-between px-3`}
                  onClick={onCallsClick}
                >
                  <MdPhone className="h-4 w-4 text-black" />
                  <span className="text-sm font-bold">Calls ({pendingRecordsStats.callCount})</span>
                  <Edit2 className="h-3 w-3 text-sahi-dark-blue" />
                </Button>
              )}
              {showMsg && (
                <Button
                  size="sm"
                  className={`${isSingleButton ? 'w-1/2' : 'flex-1'} h-10 border border-sahi-border-color bg-sahi-disable sahi-radius text-foreground hover:bg-gray-200 flex items-center justify-between px-3`}
                  onClick={onMessagesClick}
                >
                  <BsWhatsapp className="h-4 w-4 text-sahi-green" />
                  <span className="text-sm font-bold">Msgs ({pendingRecordsStats.messageCount})</span>
                  <Edit2 className="h-3 w-3 text-sahi-dark-blue" />
                </Button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };
  // const SalesPerformanceGauge = ({ actualAmount = 0, actualCount = 0, countryID = 1 }) => {
  //   const currencySymbol = useCurrency();
  //   const isMobile = useIsMobile();
  //   const { data: agencyData } = useSelector((state) => state.agencyData);

  //   // 1. Target Management
  //   const [target, setTarget] = useState(() => {
  //     const saved = localStorage.getItem("sales_target");
  //     return saved ? JSON.parse(saved) : { value: 100000, type: 'amount' };
  //   });

  //   const [isSettingTarget, setIsSettingTarget] = useState(false);
  //   const [tempTarget, setTempTarget] = useState(target.value);

  //   // 2. Data Calculation
  //   const currentActual = target.type === 'amount' ? actualAmount : actualCount;

  //   // Re-calculate these every time props or target change
  //   const secondaryPercent = 65; 
  //   const currentPercent = Math.min((currentActual / target.value) * 100, 100);

  //   // 3. Dynamic Ticks logic
  //   const dynamicTicks = React.useMemo(() => {
  //     const steps = [0, 0.2, 0.4, 0.6, 0.8, 1];
  //     return steps.map(s => {
  //       const val = s * target.value;
  //       let label = target.type === 'amount' 
  //         ? formatAmount(val, countryID)
  //         : val.toFixed(0);
  //       return {
  //         value: s * 100,
  //         valueConfig: { formatTextValue: () => label }
  //       };
  //     });
  //     // Adding currentActual here ensures ticks refresh if data changes
  //   }, [target.value, target.type, countryID, currentActual]);

  //   const handleSaveTarget = () => {
  //     const newTarget = { ...target, value: Number(tempTarget) };
  //     setTarget(newTarget);
  //     localStorage.setItem("sales_target", JSON.stringify(newTarget));
  //     setIsSettingTarget(false);
  //   };

  //   return (
  //     <div className="bg-bg-white rounded-xl md:border md:border-sahi-border-color md:shadow-md border-none shadow-none overflow-hidden h-full flex flex-col">

  //       {/* HEADER: Exact alignment replication */}
  //       <div className="p-2 pb-0 pt-0">
  //         <div className="flex items-center justify-between mb-3 mt-2">
  //           <div className="flex items-center gap-2">
  //             {/* Added pl-1 to move title left */}
  //             <span className="text-text-color text-xl sm:text-xl font-semibold pl-1">
  //               Target Tracker
  //             </span>
  //           </div>

  //           <div className="flex items-center gap-2 pr-1">
  //             {/* Added pr-1 to move button right */}
  //             <button 
  //               onClick={(e) => {
  //                 e.stopPropagation();
  //                 setIsSettingTarget(true);
  //               }}
  //               className="p-1.5 hover:bg-gray-100 rounded-md text-sahi-primary-color transition-colors"
  //             >
  //               <Settings className="h-6 w-6" />
  //             </button>
  //           </div>
  //         </div>
  //       </div>

  //       <div className="flex-1 p-4 pt-0 flex flex-col justify-between">
  //         {/* GAUGE STACK */}
  //         <div className="relative w-full max-w-[280px] mx-auto" style={{ height: '160px' }}>
  //           <div className="absolute inset-0" style={{ zIndex: 1 }}>
  //             <GaugeComponent
  //               id="velocity-main-gauge"
  //               // KEY FIX: This key forces the gauge to redraw whenever the value or target changes
  //               key={`main-${currentPercent}-${target.value}`} 
  //               type="semicircle"
  //               arc={{
  //                 width: 0.2,
  //                 padding: 0.005,
  //                 cornerRadius: 1,
  //                 subArcs: [
  //                   { limit: 30, color: '#841617' },
  //                   { limit: 60, color: '#d4af37' },
  //                   { limit: 100, color: '#0b5d1e' },
  //                 ]
  //               }}
  //               pointer={{
  //                 color: 'var(--sahi-blue)',
  //                 length: 0.80,
  //                 width: 12,
  //                 elastic: true
  //               }}
  //               labels={{
  //                 valueLabel: { hide: true },
  //                 tickLabels: {
  //                   type: 'outer',
  //                   ticks: dynamicTicks,
  //                   defaultTickValueConfig: { 
  //                     style: { fontSize: isMobile ? 10 : 12, fill: "#000000ff" } 
  //                   }
  //                 }
  //               }}
  //               value={currentPercent}
  //             />
  //           </div>

  //           <div className="absolute inset-0 pointer-events-none" style={{ zIndex: 10 }}>
  //             <GaugeComponent
  //               id="velocity-secondary-needle"
  //               // KEY FIX: Forces secondary needle redraw
  //               key={`needle-${target.type}-${target.value}`}
  //               type="semicircle"
  //               value={secondaryPercent}
  //               arc={{ width: 0, padding: 0, subArcs: [{ limit: 100, color: 'transparent' }] }}
  //               labels={{ valueLabel: { hide: true }, tickLabels: { hideMinMax: true } }}
  //               pointer={{
  //                 color: '#9ca3af',
  //                 length: 0.70,
  //                 width: 8,
  //               }}
  //             />
  //           </div>
  //         </div>

  //         {/* BOTTOM METRIC CARDS */}
  //         <div className="grid grid-cols-2 gap-2 mt-4">
  //           <div className="text-center rounded-lg flex flex-col items-center py-2.5 justify-center bg-sahi-disable border border-sahi-border-color">
  //             <div className="text-[12px] text-gray-500 font-bold ">Actual</div>
  //             <div className="text-base font-bold text-sahi-dark-blue leading-none mt-1">
  //               {target.type === 'amount' ? `${currencySymbol}${formatAmount(currentActual, countryID)}` : currentActual}
  //             </div>
  //           </div>
  //           <div className="text-center rounded-lg flex flex-col items-center py-2.5 justify-center bg-sahi-disable border border-sahi-border-color">
  //             <div className="text-[12px] text-gray-500 font-bold ">Target</div>
  //             <div className="text-base font-bold text-sahi-blue leading-none mt-1">
  //               {target.type === 'amount' ? `${currencySymbol}${formatAmount(target.value, countryID)}` : target.value}
  //             </div>
  //           </div>
  //         </div>
  //       </div>

  //       {/* SETTINGS MODAL */}
  //       <Dialog open={isSettingTarget} onOpenChange={setIsSettingTarget}>
  //         <DialogContent 
  //           onInteractOutside={(e) => e.preventDefault()}
  //           className="lg:!max-w-[400px] max-w-[100vw] p-0 gap-0 border-none shadow-2xl"
  //         >
  //           <DialogHeader className="gap-0 px-3 sm:px-4 py-3 border-b">
  //             <div className="flex items-center justify-between w-full h-8">
  //               <div className="flex items-center gap-2 flex-1 min-w-0">
  //                 <DialogClose className="p-0 w-auto h-auto flex-shrink-0 flex justify-center">
  //                   <ArrowLeft className="h-6 w-6" />
  //                 </DialogClose>
  //                 <DialogTitle className="text-lg font-medium truncate">
  //                   Target Settings
  //                 </DialogTitle>
  //               </div>
  //               <DialogClose className="hidden sm:block">
  //                 <X className="h-5 w-5" />
  //               </DialogClose>
  //             </div>
  //           </DialogHeader>

  //           <div className="p-6 space-y-6 overflow-y-auto max-h-[calc(100vh-160px)]">
  //             <div className="flex p-1 bg-sahi-disable rounded-lg border border-sahi-border-color">
  //               <button
  //                 onClick={() => setTarget({ ...target, type: 'amount' })}
  //                 className={cn(
  //                     "flex-1 py-2 text-sm font-bold rounded-md transition-all",
  //                     target.type === 'amount' ? "bg-white shadow text-sahi-green" : "text-gray-500"
  //                 )}
  //               >By Value</button>
  //               <button
  //                 onClick={() => setTarget({ ...target, type: 'count' })}
  //                 className={cn(
  //                     "flex-1 py-2 text-sm font-bold rounded-md transition-all",
  //                     target.type === 'count' ? "bg-white shadow text-sahi-green" : "text-gray-500"
  //                 )}
  //               >By Count</button>
  //             </div>

  //             <div className="space-y-2">
  //               <Label className="text-xs font-bold text-gray-400 ml-1">Monthly Goal</Label>
  //               <div className="relative">
  //                 {target.type === 'amount' && (
  //                   <span className="absolute left-4 top-1/2 -translate-y-1/2 font-bold text-gray-400 text-lg">{currencySymbol}</span>
  //                 )}
  //                 <Input
  //                   type="number"
  //                   value={tempTarget}
  //                   onChange={(e) => setTempTarget(e.target.value)}
  //                   className={cn(
  //                       "w-full bg-sahi-disable border-sahi-border-color h-14 text-xl font-bold text-sahi-dark-blue",
  //                       target.type === 'amount' && "pl-10"
  //                   )}
  //                 />
  //               </div>
  //             </div>
  //           </div>

  //           <div className="p-6 pt-0 flex gap-3">
  //             <Button variant="outline" onClick={() => setIsSettingTarget(false)} className="flex-1 h-12 font-bold sahi-secondary-button hidden sm:flex">
  //               Close
  //             </Button>
  //             <Button onClick={handleSaveTarget} className="flex-1 h-12 bg-sahi-green hover:bg-sahi-green text-white font-bold">
  //               Save Target
  //             </Button>
  //           </div>
  //         </DialogContent>
  //       </Dialog>
  //     </div>
  //   );
  // };

  // Handle task entry dialog

  const SalesPerformanceGauge = ({
    actualAmount = 0,
    actualCount = 0,
    lastMonthOrders = { value: 0, count: 0 },
    expectedValue = 0,
    countryID = 1,
    target,
    setTarget,
    isAdmin
  }) => {
    const currencySymbol = useCurrency();
    const isMobile = useIsMobile();
    const navigate = useNavigate();
    const [isSettingTarget, setIsSettingTarget] = useState(false);
    const [tempType, setTempType] = useState(target.type);
    const [tempTargetValue, setTempTargetValue] = useState(target.value);
    const [showInfo, setShowInfo] = useState(false);

    useEffect(() => {
      if (isSettingTarget) {
        setTempType(target.type);
        setTempTargetValue(target.value);
      }
    }, [isSettingTarget, target]);

    const handleProgressClick = (e, type) => {
      e.stopPropagation();
      const now = new Date();
      let month;
      if (type === 'current') {
        month = now.getMonth() + 1;
      } else {
        const lastMonthDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        month = lastMonthDate.getMonth() + 1;
      }
      navigate(`/threads-report?tID=2&m=${month}`);
    };
    const handleSaveUserTarget = async () => {
      const targetValue = Number(tempTargetValue);
      setTarget({ type: tempType, value: targetValue });

      const payload = {
        changeType: 'TGT',
        target: {
          TM: tempType === 'amount' ? 2 : 1,
          TA: tempType === 'amount' ? targetValue : 0,
          TC: tempType === 'count' ? targetValue : 0,
        },
      };

      try {
        // Ensure setUserTargetAPI is imported at the top of your file
        const response = await setUserTargetAPI(payload);
        if (!response.error) {
          setIsSettingTarget(false);
          toast.success('Target Updated.');
        }
      } catch (err) {
        toast.error('Error while setting target.');
      }
    };
    const isTargetUnset = !target.value || target.value <= 1;
    const isAmtMode = target.type === 'amount' || isTargetUnset;

    const currentActual = isAmtMode ? actualAmount : actualCount;
    const lastMonthValue = isAmtMode ? lastMonthOrders.value : lastMonthOrders.count;
    const monthlyTarget = isTargetUnset ? 0 : target.value;
    const thisMonthTotal = currentActual; // Hidden expectation

    // FIX: maxValue should at least be the actual current/last month data so bars show up even without target
    const maxValue = Math.max(lastMonthValue, monthlyTarget, thisMonthTotal, 1);

    const formatDisplay = (val) => {
      // FIX: Show 0 if value is null/undefined
      const valueToFormat = val || 0;
      if (isAmtMode) {
        if (isMobile) {
          return `${currencySymbol} ${formatAmount(valueToFormat, countryID)}`;
        }
        return (
          <div className="flex items-baseline gap-1">
            <span className="text-xs font-medium text-sahi-grey">{currencySymbol}</span>
            <FormatAmount amount={valueToFormat} countryID={countryID} showCurr={false} showZero={true} />
          </div>
        );
      }
      return Math.round(valueToFormat).toLocaleString();
    };

    const InfoCard = () => (
      <div className="bg-white border shadow-xl rounded-xl p-3 text-xs space-y-2 min-w-[180px] border-gray-200">
        <div className="flex items-center gap-2">
          <div className="h-2 w-2 rounded-full bg-sahi-orange" />
          <span className="text-gray-600 font-medium">Actual:</span>
          <span className="font-bold ml-auto">{formatDisplay(currentActual)}</span>
        </div>
        <div className="flex items-center gap-2">
          <div
            className="h-2 w-2 rounded-full"
            style={{ backgroundColor: 'color-mix(in srgb, var(--sahi-orange), transparent 50%)' }}
          />
          <span className="text-gray-600 font-medium">Expected:</span>
          <span className="font-bold ml-auto">{formatDisplay(expectedValue)}</span>
        </div>
      </div>
    );

    const ProgressPipe = ({ label, amount, colorClass, isTargetLabel = false, stackedSecondary = 0, onClick }) => {
      const actualWidth = (amount / maxValue) * 100;
      const expectedWidth = (stackedSecondary / maxValue) * 100;

      const trackBg = (() => {
        if (!colorClass) return 'bg-zinc-100';
        if (colorClass.includes('sahi-green')) return 'bg-sahi-green-light';
        if (colorClass.includes('sahi-dark-blue')) return 'bg-[#0d1f2d12]';
        if (colorClass.includes('sahi-blue')) return 'bg-sahi-blue-light';
        if (colorClass.includes('sahi-orange')) return 'bg-sahi-orange-light';
        return 'bg-zinc-100';
      })();

      return (
        <div
          className={cn("space-y-1 w-full", onClick && "cursor-pointer group/pipe")}
          onClick={onClick}
        >
          <div className="flex justify-between items-end px-1">
            <div className="text-[13px] font-medium text-text-color">{label}</div>
            <span className={cn(
              "text-sm font-bold",
              isTargetLabel && isTargetUnset ? "text-sahi-grey" : "text"
            )}>
              {/* FIX: Changed logic to show amount even if target unset, except for Target label itself */}
              {isTargetLabel && isTargetUnset ? "Not Set" : formatDisplay(amount + stackedSecondary)}
            </span>
          </div>

          <div
            className={cn("w-full h-6 rounded-full overflow-hidden shadow-inner relative border border-gray-100/30 flex transition-all group-hover/pipe:border-slate-300", trackBg)}
            style={{ borderRadius: "6px" }}
          >
            <div
              className={cn("h-full transition-all duration-1000 ease-out", colorClass)}
              style={{ width: `${Math.min(actualWidth, 100)}%` }}
            />
            {stackedSecondary > 0 && (
              <div
                className="h-full transition-all duration-1000 ease-out border-l border-white/30"
                style={{
                  width: `${Math.min(expectedWidth, 100 - actualWidth)}%`,
                  backgroundColor: 'color-mix(in srgb, var(--sahi-orange), transparent 50%)'
                }}
              />
            )}
          </div>
        </div>
      );
    };

    return (
      <div
        className="bg-bg-white rounded-xl md:border-sahi-border-color md:shadow-md h-full flex flex-col cursor-pointer hover:border-gray-300 transition-all p-2 pt-2"
      >
        <div className="flex items-center justify-between px-1 md:px-3">
          <span onClick={(e) => handleProgressClick(e, 'current')} className="text-text-color text-lg sm:text-xl font-semibold">Sales</span>
          <div className="flex items-center gap-1">
            {userRights?.addThr && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleThreadEntryOpen(2);
                }}
                className="p-1.5 hover:bg-gray-100 transition-colors text-sahi-primary-color sahi-radius"
              >
                <Plus className="h-5 w-5" />
              </button>
            )}
            <button
              onClick={(e) => { e.stopPropagation(); setIsSettingTarget(true); }}
              className="p-1.5 hover:bg-gray-100 transition-colors text-sahi-primary-color sahi-radius"
            >
              <Settings className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="flex-1 md:px-3 md:pb-3 px-1 flex flex-col justify-start space-y-3 mt-2 pb-1">
          <ProgressPipe
            label="Last Month"
            amount={lastMonthValue}
            colorClass="bg-sahi-green"
            onClick={(e) => handleProgressClick(e, 'last')}
          />

          <ProgressPipe
            label="Current Target"
            amount={monthlyTarget}
            onClick={() => setIsSettingTarget(true)}
            colorClass="bg-sahi-dark-blue"
            isTargetLabel={true}
          />

          {/* Hover/Tooltip Logic (Hidden) */}
          <div className="relative group w-full">
            {/* Tooltip hidden as per request */}
            {/* <div className="absolute left-1/2 -translate-x-1/2 bottom-[75%] mb-0 opacity-0 group-hover:opacity-100 transition-all duration-200 z-50 pointer-events-none hidden md:block group-hover:translate-y-[-8px]">
              <InfoCard />
            </div> */}

            {/* {isMobile && showInfo && (
              <>
                <div className="fixed inset-0 z-[100] bg-transparent" onClick={(e) => { e.stopPropagation(); setShowInfo(false); }} />
                <div className="absolute left-0 bottom-full mb-3 z-[101] animate-in fade-in slide-in-from-bottom-2 duration-200">
                  <InfoCard />
                </div>
              </>
            )} */}

            <ProgressPipe
              label={
                <div className="flex items-center gap-2">
                  <span>This Month</span>
                  {/* Info button hidden as per request */}
                  {/* {isMobile && (
                    <button
                      onClick={(e) => { e.stopPropagation(); setShowInfo(!showInfo); }}
                      className={cn(
                        "flex items-center justify-center h-5 w-5 rounded-full border transition-colors",
                        showInfo ? "bg-sahi-primary-color text-white" : "bg-gray-50 text-gray-400"
                      )}
                    >
                      <span className="text-[11px] font-bold italic">i</span>
                    </button>
                  )} */}
                </div>
              }
              amount={currentActual}
              stackedSecondary={0} // Hidden expected value
              colorClass="bg-sahi-orange"
              onClick={(e) => handleProgressClick(e, 'current')}
            />
          </div>
        </div>

        {/* Target Update Dialog remains same as your original provided code */}
        <Dialog open={isSettingTarget} onOpenChange={setIsSettingTarget}>
          <DialogContent onInteractOutside={(e) => e.preventDefault()} className="lg:!max-w-[400px] max-w-[100vw] p-0 gap-0 border-none shadow-2xl">
            <DialogHeader className="gap-0 px-3 sm:px-4 py-3 border-b">
              <div className="flex items-center w-full h-8">
                <DialogClose onClick={(e) => { e.stopPropagation(); setIsSettingTarget(false); }} className="flex sm:hidden flex-shrink-0 mr-2">
                  <ArrowLeft className="h-6 w-6 cursor-pointer" />
                </DialogClose>
                <DialogTitle className="flex-1 min-w-0 text-lg md:text-xl font-semibold truncate">Target Update</DialogTitle>
                <DialogClose onClick={(e) => { e.stopPropagation(); setIsSettingTarget(false); }} className="ml-2hidden sm:flex flex-shrink-0">
                  <X className="h-5 w-5 cursor-pointer" />
                </DialogClose>
              </div>
            </DialogHeader>
            <div className="p-4 flex-col space-y-6">
              <div className="p-0 space-y-6 overflow-y-auto max-h-[calc(100vh-160px)]">
                <div className="space-y-3">
                  <Label className="text-sm font-medium">Target Type</Label>
                  <div className="flex gap-6">
                    {[{ value: "amount", label: `By Revenue Amt (${useCurrency()})` }, { value: "count", label: "By Count" }].map((option) => (
                      <div key={option.value} className="flex items-center gap-2">
                        <input
                          type="radio"
                          name="targetType"
                          id={`targetType-${option.value}`}
                          checked={tempType === option.value}
                          onChange={() => setTempType(option.value)}
                          className="h-4 w-4 accent-sahi-primary-color cursor-pointer"
                        />
                        <Label htmlFor={`targetType-${option.value}`} className="text-sm text-gray-700 cursor-pointer">{option.label}</Label>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-1/2">
                    {tempType === "amount" ? (
                      <BusinessInput fieldID="amount" placeholder="e.g. 40000" label="Monthly Goal" value={tempTargetValue} onChange={(e) => setTempTargetValue(e.target.value)} maxDecimalPlaces={0} maxIntegerDigits={10} disabled={false} />
                    ) : (
                      <div className="flex-col space-y-1.5">
                        <Label>Monthly Goal</Label>
                        <Input value={tempTargetValue} onChange={(e) => { const val = e.target.value; if (val === "" || parseInt(val) >= 0) setTempTargetValue(val); }} placeholder="e.g. 40" type="number" min="0" className="h-11 text-sm" />
                      </div>
                    )}
                  </div>
                  <span className="text-sm text-muted-foreground whitespace-nowrap translate-y-3">per month</span>
                </div>
              </div>
              <div className="sm:px-0 sm:sticky sm:bottom-0 sm:bg-background pt-1">
                <div className="flex gap-3">
                  <Button onClick={handleSaveUserTarget} className="sahi-primary-button"><Check className="h-4 w-4" /> {target?.value > 0 ? 'Update Target' : 'Save Target'}</Button>
                  <Button variant="outline" tabIndex={-1} onClick={(e) => { e.stopPropagation(); setIsSettingTarget(false); }} className="sahi-secondary-button"><X className="h-5 w-5" /> Close</Button>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  };

  const handleTaskEntryOpen = () => {
    setTaskEntryPrefillData(null);
    setIsTaskEntryOpen(true);
  };

  const handleTaskClassEntryOpen = (classId) => {
    setTaskEntryPrefillData({ taskClass: classId });
    setIsTaskEntryOpen(true);
  };

  const TasksQuickAccess = () => {
    const taskCards = [
      { key: "own", label: "Own Work", singularLabel: "Own Work", icon: ArrowDown, classId: 1, type: "own" },
      { key: "delegated", label: "Delegated", singularLabel: "Delegated", icon: ArrowUp, classId: 1, type: "delegated" },
      { key: "decision", label: "Decision", singularLabel: "Decision", icon: GitFork, classId: [3, 4], type: "decision" },
      { key: "meeting", label: "Meeting", singularLabel: "Meeting", icon: Calendar, classId: 2, type: "meeting" }
    ];

    const { headerTitle, cardCounts, mode } = (() => {
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);

      const next7DaysEnd = new Date();
      next7DaysEnd.setDate(next7DaysEnd.getDate() + 7);
      next7DaysEnd.setHours(23, 59, 59, 999);

      const myUserIDs = getMyAgenciesMappedIDs('UserID').map(Number);
      const userIDsToCheck = myUserIDs.length > 0 ? myUserIDs : [Number(currentUserID)];

      // 1. Check if there are active tasks due on or before today
      let hasTasksTillToday = false;
      if (Array.isArray(taskData)) {
        hasTasksTillToday = taskData.some((task) => {
          if (task.Status !== 1 && task.status !== 1 && task.Sts !== 1) return false;
          const assigneeID = Number(task.POCUserID || task.pocUserID || task.uID || task.UID || 0);
          const creatorID = Number(task.CreatedUserID || task.createdUserID || task.createdUID || 0);
          const isAssignedToMe = userIDsToCheck.includes(assigneeID);
          const isCreatedByMe = userIDsToCheck.includes(creatorID);
          const obsIDs = extractObserverUserIDs(task);
          const isObserver = obsIDs.some(id => userIDsToCheck.includes(Number(id)));
          if (!isAssignedToMe && !isCreatedByMe && !isObserver) return false;

          const taskDT = task.DueDT || task.dueDT || task.DT || task.dt;
          if (!taskDT || isNaN(new Date(taskDT).getTime())) return false;
          return new Date(taskDT) <= todayEnd;
        });
      }

      // 2. Check if there are active tasks due in the next 7 days (after today)
      let hasTasksNext7Days = false;
      if (!hasTasksTillToday && Array.isArray(taskData)) {
        hasTasksNext7Days = taskData.some((task) => {
          if (task.Status !== 1 && task.status !== 1 && task.Sts !== 1) return false;
          const assigneeID = Number(task.POCUserID || task.pocUserID || task.uID || task.UID || 0);
          const creatorID = Number(task.CreatedUserID || task.createdUserID || task.createdUID || 0);
          const isAssignedToMe = userIDsToCheck.includes(assigneeID);
          const isCreatedByMe = userIDsToCheck.includes(creatorID);
          const obsIDs = extractObserverUserIDs(task);
          const isObserver = obsIDs.some(id => userIDsToCheck.includes(Number(id)));
          if (!isAssignedToMe && !isCreatedByMe && !isObserver) return false;

          const taskDT = task.DueDT || task.dueDT || task.DT || task.dt;
          if (!taskDT || isNaN(new Date(taskDT).getTime())) return false;
          const dt = new Date(taskDT);
          return dt > todayEnd && dt <= next7DaysEnd;
        });
      }

      let evaluatedMode = "all";
      let title = "Tasks";
      if (hasTasksTillToday) {
        evaluatedMode = "today";
        title = "Today's Tasks";
      } else if (hasTasksNext7Days) {
        evaluatedMode = "upcoming";
        title = "Upcoming Tasks";
      }

      const counts = { own: 0, delegated: 0, decision: 0, meeting: 0 };
      if (Array.isArray(taskData)) {
        taskData.forEach((task) => {
          if (task.Status !== 1 && task.status !== 1 && task.Sts !== 1) return;
          const assigneeID = Number(task.POCUserID || task.pocUserID || task.uID || task.UID || 0);
          const creatorID = Number(task.CreatedUserID || task.createdUserID || task.createdUID || 0);
          const isAssignedToMe = userIDsToCheck.includes(assigneeID);
          const isCreatedByMe = userIDsToCheck.includes(creatorID);
          const classId = Number(task.Class || task.class || task.taskClass || task.TaskClass || 1);

          // Apply date filter based on mode
          const taskDT = task.DueDT || task.dueDT || task.DT || task.dt;
          const parsedDT = taskDT && !isNaN(new Date(taskDT).getTime()) ? new Date(taskDT) : null;
          if (evaluatedMode === "today") {
            if (!parsedDT || parsedDT > todayEnd) return;
          } else if (evaluatedMode === "upcoming") {
            if (!parsedDT || parsedDT <= todayEnd || parsedDT > next7DaysEnd) return;
          }

          if (!isAssignedToMe && !isCreatedByMe) {
            const obsIDs = extractObserverUserIDs(task);
            const isObserver = obsIDs.some(id => userIDsToCheck.includes(Number(id)));
            if (classId === 2 && isObserver) {
              counts.meeting++;
            }
            return;
          }

          if (isAssignedToMe) {
            counts.own++;
          } else if (isCreatedByMe) {
            counts.delegated++;
          }

          if (classId === 3 || classId === 4) {
            counts.decision++;
          } else if (classId === 2) {
            counts.meeting++;
          }
        });
      }

      return { headerTitle: title, cardCounts: counts, mode: evaluatedMode };
    })();

    const renderClassButton = (cls, isMobileBtn = false) => {
      const IconComponent = cls.icon;
      const primaryClassId = Array.isArray(cls.classId) ? cls.classId[0] : cls.classId;
      const configCls = (taskClassConfig?.taskClasses || []).find(c => c.id === primaryClassId) || {
        color: "#0D1F2D",
        bgColor: "rgba(13,31,45,0.08)"
      };
      const count = cardCounts[cls.key] || 0;
      const displayLabel = cls.label;

      const handleClick = (e) => {
        e?.stopPropagation();
        let periodParam = mode === "today" ? "&period=today" : (mode === "upcoming" ? "&period=week" : "");
        if (count === 0) {
          handleTaskClassEntryOpen(primaryClassId);
        } else {
          if (cls.key === "own") {
            navigate(`/tasks?ownership=own${periodParam}`);
          } else if (cls.key === "delegated") {
            navigate(`/tasks?ownership=given${periodParam}`);
          } else {
            const classParamValue = Array.isArray(cls.classId) ? cls.classId.join(',') : cls.classId;
            navigate(`/tasks?class=${classParamValue}${periodParam}`);
          }
        }
      };

      return (
        <button
          key={cls.key}
          type="button"
          onClick={handleClick}
          className={`flex flex-col items-start justify-between gap-[10px] px-[7px] pt-[7px] pb-[7px] pr-[8px] rounded-[7px] bg-[#0D1F2D08] border border-[#0D1F2D20] text-left active:scale-95 transition-all duration-200 w-full ${!isMobileBtn ? 'cursor-pointer' : ''}`}
        >
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center justify-center w-[24px] h-[24px] rounded-[5px]" style={{ backgroundColor: configCls.color }}><IconComponent className="h-3.5 w-3.5" strokeWidth={1.8} style={{ color: '#fff' }} /></div>
            {count === 0 ? (
              <Plus className="h-4 w-4" strokeWidth={2.5} style={{ color: configCls.color }} />
            ) : (
              <span className="text-[16px] font-semibold" style={{ color: configCls.color }}>{count}</span>
            )}
          </div>
          <span className="text-[11px] font-semibold text-[#0D1F2D] whitespace-nowrap">
            {cls.key === "own" ? (
              <>
                <span className="max-[349px]:inline hidden">Own</span>
                <span className="min-[350px]:inline hidden">Own Work</span>
              </>
            ) : (
              displayLabel
            )}
          </span>
        </button>
      );
    };

    const handleHeaderClick = (e) => {
      e?.stopPropagation();
      let periodParam = mode === "today" ? "?period=today" : (mode === "upcoming" ? "?period=week" : "");
      navigate(`/tasks${periodParam}`);
    };

    if (isMobile) {
      return (
        <div
          className="w-full bg-white rounded-xl px-[10px] pt-[10px] pb-[10px] flex flex-col gap-3 cursor-pointer"
          onClick={handleHeaderClick}
        >
          <div className="flex items-center justify-between w-full">
            <span
              onClick={handleHeaderClick}
              className="text-text-color text-[18px] font-semibold text-left cursor-pointer hover:text-sahi-primary-color transition-colors"
            >
              {headerTitle}
            </span>
            <button
              type="button"
              onClick={(e) => {
                e?.stopPropagation();
                handleTaskClassEntryOpen(1);
              }}
              className="p-1 rounded-md text-sahi-primary-color hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <Plus className="h-5 w-5" />
            </button>
          </div>
          <div className="grid grid-cols-4 gap-[10px] w-full" onClick={(e) => e?.stopPropagation()}>
            {taskCards.map((cls) => renderClassButton(cls, true))}
          </div>
        </div>
      );
    }

    return (
      <div
        className="w-full bg-bg-white rounded-xl md:border md:border-sahi-border-color md:shadow-md border-none shadow-none flex flex-col md:pb-3 pb-0.5 cursor-pointer"
        onClick={handleHeaderClick}
      >
        <div className="flex items-center justify-between gap-2 p-3 px-4 md:px-5 pb-3">
          <span
            onClick={handleHeaderClick}
            className="text-text-color text-lg sm:text-xl font-semibold cursor-pointer hover:text-sahi-primary-color transition-colors"
          >
            {headerTitle}
          </span>
          <button
            type="button"
            onClick={(e) => {
              e?.stopPropagation();
              handleTaskClassEntryOpen(1);
            }}
            className="p-1.5 rounded-md text-sahi-primary-color hover:bg-gray-100 transition-colors cursor-pointer"
          >
            <Plus className="h-6 w-6" />
          </button>
        </div>
        <div className="px-3 md:px-5" onClick={(e) => e?.stopPropagation()}>
          <div className="grid grid-cols-4 gap-[10px] w-full">
            {taskCards.map((cls) => renderClassButton(cls, false))}
          </div>
        </div>
      </div>
    );
  };

  const handleRepeatTaskEntryOpen = (prefillData) => {
    setTaskEntryPrefillData(prefillData);
    setIsTaskEntryOpen(true);
  };

  // Handle thread entery dialog
  const handleThreadEntryOpen = (threadTypeID) => {
    setCurrentThreadTypeID(threadTypeID);
    setIsThreadEntryOpen(true);
  };

  const OrderHistoryLeaderboard = ({
    last3MonthsOrders = [],
    currencySymbol,
    countryID,
    onThreadEntryOpen,
    userRights
  }) => {
    const navigate = useNavigate();
    const isMobile = useIsMobile();
    const { data: activeData } = useSelector((state) => state.activeData);
    const authData = getAuthData();
    const currentUserID = authData?.UserID;
    const { data: agencyData } = useSelector((state) => state.agencyData);

    const getStatsByDay = (dayOffset = 0) => {
      try {
        const statsData = JSON.parse(activeData?.RcntOrds || "[]");
        const targetDate = format(addDays(new Date(), dayOffset), "yyyy-MM-dd");

        let totalValue = 0;
        let totalCount = 0;

        statsData.forEach(item => {
          if (item.DT === targetDate) {
            const isMine = item.UID === Number(currentUserID);
            const isManaged = managedUserIDs.includes(item.UID);

            if (isAdmin || (isSupervisor && (isMine || isManaged)) || isMine) {
              totalValue += (item.RA || 0);
              totalCount += (item.RC || 0);
            }
          }
        });

        return { value: totalValue, count: totalCount };
      } catch (e) {
        return { value: 0, count: 0 };
      }
    };

    const timeMetrics = [
      { label: "Last Month", ...last3MonthsOrders[1], link: `/threads-report?tID=2&m=${last3MonthsOrders[1]?.monthNumber}` },
      { label: "This Month", ...last3MonthsOrders[0], link: `/threads-report?tID=2&m=${last3MonthsOrders[0]?.monthNumber}` },
      { label: "Yesterday", ...getStatsByDay(-1), link: `/threads-report?tID=2&m=${currMonthNumber}&prd=Y` },
      { label: "Today", ...getStatsByDay(0), link: `/threads-report?tID=2&m=${currMonthNumber}&prd=T` },
    ];

    const allMetricsAreZero = timeMetrics.every(
      metric => !metric.value && !metric.count
    );

    if (allMetricsAreZero) return null;

    return (
      <Card
        className="flex flex-col overflow-hidden bg-sahi-white md:shadow-md !rounded-xl border-none shadow-sm gap-0 cursor-pointer hover:border-slate-300 transition-all"
        onClick={() => navigate(`/threads-report?tID=2&m=${currMonthNumber}`)}
      >
        <div className="flex items-center justify-between px-3 md:px-4 pt-1.5 md:pt-1 md:-mt-2">  <div className="flex items-center px-1">
          <span className="text-text-color text-lg font-semibold">Growth</span>
        </div>

          <div className="flex items-center gap-2">
            {userRights?.addThr && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onThreadEntryOpen && onThreadEntryOpen(2);
                }}
                className="h-9 w-9 flex items-center justify-center hover:bg-gray-100  transition-colors text-sahi-primary-color sahi-radius"
              >
                <Plus className="h-5 w-5" />
              </button>
            )}
          </div>
        </div>

        {/* CONTENT: Standardized padding for mobile (px-3 pb-4) */}
        <CardContent className="px-3 pb-4 md:px-5 md:pb-5 m-0 pt-2">
          <div className="space-y-2">
            {timeMetrics.map((metric, index) => (
              <div
                key={index}
                className="flex items-center justify-between p-3 sahi-radius bg-sahi-disable border border-sahi-border-color shadow-sm cursor-pointer hover:bg-gray-100 transition-all group"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(metric.link);
                }}
              >
                <div className="flex items-center min-w-0">
                  <span className="font-bold text-[14px] md:text-[15px] text-gray-700">
                    {metric.label}
                  </span>
                </div>

                <div className="text-right flex-shrink-0 ml-2">
                  <div className="font-bold text-base md:text-lg flex items-baseline justify-end gap-1">
                    <span className="text-xs text-sahi-grey font-medium">
                      {currencySymbol}
                    </span>
                    <span className="leading-none text-sahi-green">
                      {/* Using Math.round to match your "no float" requirement */}
                      {isMobile ?
                        formatAmount(Math.round(metric.value), agencyData.CountryID) :
                        <FormatAmount amount={Math.round(metric.value)} countryID={agencyData.CountryID} showCurr={false} showZero={true} />
                      }
                    </span>
                    <span className="text-xs md:text-sm font-semibold text-sahi-dark-blue opacity-70">
                      ({metric.count?.toLocaleString() || "0"})
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    );
  };


  const TodayTasksCard = () => {
    const navigate = useNavigate();
    const currentUserID = getAuthData()?.UserID;
    const { data: taskData } = useSelector((state) => state.taskData);

    const getCombinedStats = (type) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return taskData?.filter(t => {
        const isMine = Number(t.POCUserID) === Number(currentUserID);
        const isOpen = t.Status === 1;
        const dueDT = new Date(t.DueDT);
        dueDT.setHours(0, 0, 0, 0);

        const isTodayOrOverdue = dueDT <= today;
        if (!isMine || !isOpen || !isTodayOrOverdue) return false;

        // Corrected Type Logic
        const taskType = t.TaskType?.trim(); // Handle potential whitespace
        if (type === "Call") return taskType === "Call";
        if (type === "Message") return taskType === "Message";

        // "Other" logic: If it's NOT a call and NOT a message, it counts as Other
        if (type === "Other") {
          return taskType !== "Call" && taskType !== "Message";
        }

        return false;
      }).length || 0;
    };

    // Ensure your categories use these exact keys
    const categories = [
      { icon: MdPhone, color: "var(--sahi-dark-blue)", type: "Call" },
      { icon: BsWhatsapp, color: "var(--sahi-green)", type: "Message" },
      { icon: ListTodo, color: "var(--sahi-dark-blue)", type: "Other" },
    ];



    return (
      <div className="bg-bg-white rounded-xl md:border md:border-sahi-border-color md:shadow-md border-none shadow-none overflow-hidden h-full flex flex-col">
        {/* Reduced padding to save space */}
        <div className="p-4 md:px-6 pb-2 pt-3">
          <div className="flex items-center justify-between">
            <span className="text-text-color text-[20px] font-semibold">Pending Tasks</span>
            <button onClick={() => navigate('/tasks')} className="p-1 hover:bg-gray-100 rounded text-sahi-primary-color transition-colors">
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>

        {/* Side-by-side Icon and Count inside compact gray boxes */}
        <div className="flex-1 px-4 md:px-6 pb-4 flex items-center">
          <div className="grid grid-cols-3 gap-2 w-full">
            {categories.map((cat, idx) => {
              const total = getCombinedStats(cat.type);
              return (
                <div
                  key={idx}
                  onClick={() => navigate(`/tasks?type=${cat.type}`)}
                  className="bg-gray-100/80 border border-gray-200 rounded-lg py-3 px-3 flex items-center justify-center gap-2 cursor-pointer hover:bg-gray-200 transition-all"
                >
                  <cat.icon className="h-4 w-4 shrink-0" style={{ color: cat.color }} />
                  <span className="text-lg font-bold text-slate-800 leading-none">{total}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  const MonthlyComparisonChart = ({ currentMonthData, lastMonthData }) => {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);
    const isMobile = useIsMobile();
    const { data: agencyData } = useSelector((state) => state.agencyData);
    const currencySymbol = useCurrency();

    useEffect(() => {
      if (!chartRef.current || !agencyData) return;
      if (chartInstance.current) chartInstance.current.destroy();

      const todayDay = new Date().getDate();
      const processedCurrentSeries = currentMonthData.dailyValues.map((val, idx) => {
        return (idx + 1 > todayDay) ? null : val;
      });

      const options = {
        series: [
          { name: lastMonthData.monthName, data: lastMonthData.dailyValues },
          { name: currentMonthData.monthName, data: processedCurrentSeries }
        ],
        chart: {
          height: 210,
          type: 'line',
          toolbar: { show: false },
          parentHeightOffset: 0,
          fontFamily: 'inherit',
          sparkline: { enabled: false }
        },
        colors: ["var(--sahi-dark-blue)", "var(--sahi-green)"],
        stroke: { curve: 'smooth', width: 2.5 },
        markers: { size: 3.5, strokeWidth: 0, hover: { size: 5 } },
        grid: {
          borderColor: '#f1f1f1',
          padding: {
            top: -8, // Pulled graph area up slightly more
            right: 20,
            bottom: -10,
            left: 10
          }
        },
        xaxis: {
          categories: currentMonthData.dates,
          labels: {
            offsetY: -5,
            formatter: function (val) {
              const v = parseInt(val);
              if (isMobile) return [1, 10, 20, 30].includes(v) ? v : '';
              return (v === 1 || v % 5 === 0) ? v : '';
            },
            style: { colors: '#9ca3af', fontSize: '10px' }
          },
          axisBorder: { show: false },
          axisTicks: { show: false }
        },
        yaxis: {
          labels: {
            offsetX: -10,
            style: { colors: '#9ca3af', fontSize: '10px' },
            formatter: (val) => formatAmount(val, agencyData.CountryID)
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          fontSize: '12px',
          fontWeight: 600,
          offsetY: -5,
          markers: { width: 8, height: 8, radius: 12 },
          itemMargin: { horizontal: 10, vertical: 0 }
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: { formatter: (val) => val !== null ? `${currencySymbol} ${formatAmount(val, agencyData.CountryID)}` : undefined }
        },
      };

      chartInstance.current = new ApexCharts(chartRef.current, options);
      chartInstance.current.render();

      return () => { if (chartInstance.current) chartInstance.current.destroy(); };
    }, [currentMonthData, lastMonthData, agencyData, isMobile, currencySymbol]);

    return (
      <div className="bg-bg-white rounded-xl md:border md:border-sahi-border-color md:shadow-md border-none shadow-none overflow-hidden h-full p-4 pt-2">
        {/* Reduced pt-4 to pt-2 to move title/legend row upward */}
        <div className="flex items-center justify-between h-8 mb-[12px]">
          <span className="text-text-color text-[20px] font-semibold">Monthly Trend</span>
        </div>

        {/* Graph container moved up slightly more with -mt-8 */}
        <div ref={chartRef} className="w-full -mt-8"></div>
      </div>
    );
  };


  if (isMobile) {
    return (
      <div className="flex flex-col h-screen">
        {/* Main Content Area - Mobile */}
        <PullToRefreshContainer
          className="flex-1 overflow-y-auto overflow-x-hidden pt-20 pb-24 bg-bg-grey"
          onRefresh={() => window.location.reload()}
        >
          <div className="space-y-3">
            {/* Mobile Agency Switcher */}
            <DashboardHeader isMobile={true} dashboardHeaderData={dashboardHeaderData} isAdmin={isAdmin} />

            {/* <div>
              <PricingFooter agencyData={agencyData} isVisible={isPricingVisible} />
            </div> */}
            {/* Dashboard Tabs Selector */}
            {/* <div className="px-4 pt-1 pb-1">
              <div className="flex bg-sahi-disable p-1 rounded-xl w-full border border-sahi-border-color">
                {['Growth', 'Tasks', 'Network'].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveMobileTab(tab)}
                    className={cn(
                      "flex-1 py-2 text-center text-sm font-semibold rounded-lg transition-all",
                      activeMobileTab === tab
                        ? "bg-white text-sahi-primary-color shadow-sm"
                        : "text-sub-text-color hover:text-text-color"
                    )}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div> */}

            {/* Tab Contents */}
            {activeMobileTab === 'Growth' && (
              <>
                {/* Company Goal display */}
                {SHOW_BUSINESS_GOALS && <GoalsDashboardCard isMobile={true} />}
                {/* Quick Actions (NextAction component) */}
                {/* {SHOW_QUICK_ACTIONS && (
                  <div className="px-4">
                    <NextAction />
                  </div>
                )} */}

                <div className="px-4">
                  <SalesPerformanceGauge
                    actualAmount={premiumMetrics.orderValues}
                    actualCount={premiumMetrics.orderCounts}
                    lastMonthOrders={last3MonthsOrders[1] || { value: 0, count: 0 }}
                    expectedValue={calculateExpectedPipeline()}
                    countryID={agencyData?.CountryID}
                    target={target}
                    setTarget={setTarget}
                  />
                </div>


                {SHOW_TASKS_QUICK_ACCESS && (
                  <div className="px-4">
                    <TasksQuickAccess />
                  </div>
                )}

                {/* Quick Actions (Mobile Action Center) - Pending Tasks */}
                {(tasksData.todayTasks.length > 0 || tasksData.overdueTasks.length > 0 || pendingRecordsStats.total > 0) && (
                  <MobileActionCenter
                    pendingRecordsStats={pendingRecordsStats}
                    onCallsClick={() => handlePendingRecordsClick('Call')}
                    onMessagesClick={() => handlePendingRecordsClick('Message')}
                    tasksCount={taskTimeCategories}
                    onTasksClick={(period) => {
                      navigate(`/tasks?period=${period}`);
                    }}
                  />
                )}

                {/* 3. Sales Inquiry Funnel - Mobile */}
                <div className="px-4" data-tour="inq-signup-funnel">
                  <InqOpportunities
                    businessActivities={businessActivities}
                    onThreadEntryOpen={handleThreadEntryOpen}
                    threadData={threadData}
                    isMobile={true}
                    onThreadStagesModalOpen={setIsThreadStagesModalOpen}
                    onImportDialogOpen={setImportDialogOpen}
                    isAdmin={isAdmin}
                    userRights={userRights}
                  />
                </div>

                <WebstoreSetupBanner />

                <div className="px-4 space-y-4" data-tour="inq-signup-leaderboard">
                  <div className="flex-1">
                    {!isAdmin || cntMaxUsers == 1 ? (
                      <OrderHistoryLeaderboard
                        last3MonthsOrders={last3MonthsOrders}
                        currencySymbol={currencySymbol}
                        countryID={agencyData.CountryID}
                        onThreadEntryOpen={handleThreadEntryOpen}
                        userRights={userRights}
                      />
                    ) : null}
                  </div>
                  {isInqOnly && <ProductLeaderboard />}
                </div>

                {/* 5.5 Customer Activity Breakdown - Mobile */}
                {inactiveStats.total > 0 && !isSmartSellerMode() && (
                  <div className="px-4" ref={inactiveSectionRef}>
                    <div className="w-full bg-white rounded-xl px-[10px] pt-[10px] pb-[10px] flex flex-col gap-3">
                      <div
                        className="flex items-center justify-between cursor-pointer active:opacity-80 transition-opacity"
                        onClick={() => navigate('/growth?tab=contacts&t=C')}
                      >
                        <span className="text-text-color text-[18px] font-semibold hover:text-sahi-primary-color transition-colors">
                          Customer Inactivity
                        </span>
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            setCurrentConnType("Customer");
                            setIsConnectionEntryOpen(true);
                          }}
                          className="p-1 rounded-md text-sahi-primary-color hover:bg-gray-100 transition-colors cursor-pointer"
                        >
                          <Plus className="h-5 w-5" />
                        </button>
                      </div>
                      <div className="flex items-center gap-[6px] w-full">
                        {/* 1. Active Customers - Green (#0B5D1E) */}
                        <button
                          type="button"
                          onClick={() => navigate(`/growth?tab=contacts&t=C&la=2`)}
                          className="flex flex-1 basis-0 flex-col items-start justify-between gap-[8px] px-[6px] pt-[7px] pb-[7px] pr-[6px] rounded-[7px] bg-[#0D1F2D08] border border-[#0D1F2D20] text-left active:scale-95 transition-all duration-200 cursor-pointer overflow-hidden"
                        >
                          <div className="flex items-center justify-between w-full">
                            <div className="flex items-center justify-center w-[22px] h-[22px] min-[360px]:w-[24px] min-[360px]:h-[24px] rounded-[5px] bg-[#0B5D1E] shrink-0">
                              <UserCheck className="h-3 w-3 min-[360px]:h-3.5 min-[360px]:w-3.5 text-white" strokeWidth={2} />
                            </div>
                            <span className="text-[14px] min-[360px]:text-[16px] font-semibold text-[#0B5D1E]">
                              {inactiveStats.countActive}
                            </span>
                          </div>
                          <span className="text-[11px] min-[360px]:text-[12px] font-semibold text-[#0D1F2D] whitespace-nowrap truncate w-full">
                            Active
                          </span>
                        </button>

                        {/* 2. 30+ Days - Sahi Yellow (#D48B00) */}
                        <button
                          type="button"
                          onClick={() => navigate(`/growth?tab=contacts&na=2`)}
                          className="flex flex-1 basis-0 flex-col items-start justify-between gap-[8px] px-[6px] pt-[7px] pb-[7px] pr-[6px] rounded-[7px] bg-[#0D1F2D08] border border-[#0D1F2D20] text-left active:scale-95 transition-all duration-200 cursor-pointer overflow-hidden"
                        >
                          <div className="flex items-center justify-between w-full">
                            <div className="flex items-center justify-center w-[22px] h-[22px] min-[360px]:w-[24px] min-[360px]:h-[24px] rounded-[5px] bg-sahi-yellow shrink-0">
                              <Clock className="h-3 w-3 min-[360px]:h-3.5 min-[360px]:w-3.5 text-white" strokeWidth={1.8} />
                            </div>
                            <span className="text-[14px] min-[360px]:text-[16px] font-semibold text-sahi-yellow">
                              {inactiveStats.count30}
                            </span>
                          </div>
                          <span className="text-[11px] min-[360px]:text-[12px] font-semibold text-[#0D1F2D] whitespace-nowrap truncate w-full">
                            30+ Days
                          </span>
                        </button>

                        {/* 3. 90+ Days - Burnt Orange (#BF5700) */}
                        <button
                          type="button"
                          onClick={() => navigate(`/growth?tab=contacts&na=4`)}
                          className="flex flex-1 basis-0 flex-col items-start justify-between gap-[8px] px-[6px] pt-[7px] pb-[7px] pr-[6px] rounded-[7px] bg-[#0D1F2D08] border border-[#0D1F2D20] text-left active:scale-95 transition-all duration-200 cursor-pointer overflow-hidden"
                        >
                          <div className="flex items-center justify-between w-full">
                            <div className="flex items-center justify-center w-[22px] h-[22px] min-[360px]:w-[24px] min-[360px]:h-[24px] rounded-[5px] bg-[#BF5700] shrink-0">
                              <History className="h-3 w-3 min-[360px]:h-3.5 min-[360px]:w-3.5 text-white" strokeWidth={1.8} />
                            </div>
                            <span className="text-[14px] min-[360px]:text-[16px] font-semibold text-[#BF5700]">
                              {inactiveStats.count90}
                            </span>
                          </div>
                          <span className="text-[11px] min-[360px]:text-[12px] font-semibold text-[#0D1F2D] whitespace-nowrap truncate w-full">
                            90+ Days
                          </span>
                        </button>

                        {/* 4. Unknown - Dark Crimson Red (#991B1B) */}
                        <button
                          type="button"
                          onClick={() => navigate(`/growth?tab=contacts&na=0`)}
                          className="flex flex-1 basis-0 flex-col items-start justify-between gap-[8px] px-[6px] pt-[7px] pb-[7px] pr-[6px] rounded-[7px] bg-[#0D1F2D08] border border-[#0D1F2D20] text-left active:scale-95 transition-all duration-200 cursor-pointer overflow-hidden"
                        >
                          <div className="flex items-center justify-between w-full">
                            <div className="flex items-center justify-center w-[22px] h-[22px] min-[360px]:w-[24px] min-[360px]:h-[24px] rounded-[5px] bg-[#991B1B] shrink-0">
                              <HelpCircle className="h-3 w-3 min-[360px]:h-3.5 min-[360px]:w-3.5 text-white" strokeWidth={1.8} />
                            </div>
                            <span className="text-[14px] min-[360px]:text-[16px] font-semibold text-[#991B1B]">
                              {inactiveStats.countUnknown}
                            </span>
                          </div>
                          <span className="text-[11px] min-[360px]:text-[12px] font-semibold text-[#0D1F2D] truncate w-full">
                            Unknown
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <AppDownloadBanner />

                {/* Quick Access panel at bottom of mobile view */}
                <div className="px-4 pb-20">
                  <NextAction />
                </div>
              </>
            )}

            {activeMobileTab === 'Tasks' && (
              <div className="px-4 pb-20">
                <div className="flex flex-col items-center justify-center p-12 bg-white rounded-xl border border-sahi-border-color shadow-sm text-center">
                  <div className="text-sahi-grey text-4xl mb-3">📋</div>
                  <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">Tasks</p>
                  <p className="text-sm font-semibold text-text-color mb-2">Coming Soon!</p>
                  <p className="text-xs text-sub-text-color">We are working hard to build this section.</p>
                </div>
              </div>
            )}

            {activeMobileTab === 'Network' && (
              <div className="px-4 pb-20">
                <div className="flex flex-col items-center justify-center p-12 bg-white rounded-xl border border-sahi-border-color shadow-sm text-center">
                  <div className="text-sahi-grey text-4xl mb-3">🌐</div>
                  <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">Network</p>
                  <p className="text-sm font-semibold text-text-color mb-2">Coming Soon!</p>
                  <p className="text-xs text-sub-text-color">We are working hard to build this section.</p>
                </div>
              </div>
            )}
          </div>
        </PullToRefreshContainer>

        {/* Dialogs - Mobile */}
        <TaskEntry
          triggerButton={false}
          open={isTaskEntryOpen}
          onOpenChange={(open) => { setIsTaskEntryOpen(open); if (!open) setTaskEntryPrefillData(null); }}
          prefilledData={taskEntryPrefillData}
        />

        <ConnectionEntryDialog
          triggerButton={false}
          open={isConnectionEntryOpen}
          onOpenChange={setIsConnectionEntryOpen}
          initialConnType={currentConnType}
        />

        {selectedConnection && (
          <ConnectionDetailsWrapper
            isOpen={isDetailOpen}
            onClose={handleDetailClose}
            connID={selectedConnection.connID}
          />
        )}

        <ThreadEntry
          triggerButton={false}
          open={isThreadEntryOpen}
          onOpenChange={setIsThreadEntryOpen}
          threadTypeID={currentThreadTypeID}
          calledFrom={(isInqOnly && currentThreadTypeID == 2) ? "ORDDONE" : ""}
        />

        <UpgradeSubscription open={upgradeOpen} onClose={setIsUpgradeOpen} />

        {/* Thread Stages Modal */}
        {isThreadStagesModalOpen && (
          <MastersDialog
            open={isThreadStagesModalOpen}
            onClose={() => setIsThreadStagesModalOpen(false)}
            masterType="threadStages"
            openEntry={false}
            directAdd={false}
          />
        )}

        <ImpDialog
          open={importDialogOpen}
          onOpenChange={setImportDialogOpen}
        />

        <RecordHistoryDialog
          isOpen={recordHistoryOpen}
          onClose={() => {
            setRecordHistoryOpen(false);
            setRecordHistoryFilter(null);
            setPendingRecordsData([]);
          }}
          threadData={threadData}
          threadTypes={threadTypes}
          records={pendingRecordsData}
          getExecutiveName={(uid) => {
            const user = userData.find(u => u.UserID === uid);
            return user ? user.Name : "";
          }}
          getRelativeDateText={(date) => {
            if (!date) return "N/A";
            return new Date(date).toLocaleDateString();
          }}
          onRecordEntryOpen={() => { }}
          connectionName="Details Pending"
          users={userData}
          connID={null}
          connIDs={pendingRecordsData.map(r => r.ConnID)}
          onRefreshRecords={handleRefreshPendingRecords}
          recordTypeFilter={recordHistoryFilter}
          connectionData={connectionData}
          isDashboardCall={true}
        />

      </div>
    );
  };

  return (
    <div className="flex flex-col lg:flex-row min-h-screen md:bg-bg-grey bg-sahi-white">
      {/* Main Content Area - Desktop */}
      <div className="flex-1 md:p-4 py-20 pt-8 md:bg-bg-grey bg-sahi-white overflow-x-hidden">        <div className="4xl:space-y-4 space-y-4">

        {/* Top row: Always Dashboard Header */}
        <div className="col-span-full">
          <DashboardHeader
            dashboardHeaderData={dashboardHeaderData}
            isAdmin={isAdmin}
          />
        </div>

        {/* Desktop Company Goal Display Card */}
        {SHOW_BUSINESS_GOALS && <GoalsDashboardCard isMobile={false} />}

        <div className="flex flex-col xl:flex-row gap-4 px-0 items-start">

          {/* LEFT STACK (60%): Funnel + Feedback */}
          <div className="w-full xl:w-[60%] flex flex-col gap-4">

            {/* <div className={cn("grid gap-4", isSmartSellerMode() ? "grid-cols-3" : "grid-cols-3")}>
              {dashboardHeaderData.metrics.map((metric, index) => {
                return (
                  <div key={index} className="bg-bg-white rounded-xl py-4 md:border md:border-sahi-border-color md:shadow-md text-center cursor-pointer hover:bg-gray-50" onClick={() => handleMetricClick(metric.label)}>
                    <div className="text-3xl font-bold mb-1" style={{ color: metric.color }}>{metric.value}</div>
                    <div className="text-[14px] font-medium text-gray-600 truncate px-1">{metric.label}</div>
                  </div>
                );
              })}
            </div> */}
            {pendingRecordsStats.total > 0 && (
              <DetailsPending
                callCount={pendingRecordsStats.callCount}
                messageCount={pendingRecordsStats.messageCount}
                totalCount={pendingRecordsStats.total}
                onCallsClick={() => handlePendingRecordsClick('Call')}
                onMessagesClick={() => handlePendingRecordsClick('Message')}
              />
            )}

            {/* 2. Sales Pipeline / Funnel */}
            <InqOpportunities
              businessActivities={businessActivities}
              onThreadEntryOpen={handleThreadEntryOpen}
              threadData={threadData}
              isMobile={false}
              onThreadStagesModalOpen={setIsThreadStagesModalOpen}
              onImportDialogOpen={setImportDialogOpen}
              isAdmin={isAdmin}
              userRights={userRights}
            />

            {/* 3. Feedback Buttons */}
            {SHOW_QUICK_ACTIONS && <NextAction />}
          </div>

          {/* RIGHT STACK (40%): Hot/Cold Cards + Details Pending + Target + Ords */}
          <div className="w-full xl:w-[40%] flex flex-col gap-4">
            {/* {(!isSmartSellerMode() &&
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-bg-white rounded-xl py-4 md:border md:border-sahi-border-color md:shadow-md text-center cursor-pointer hover:bg-gray-50" onClick={() => handleMetricClick('Hot Leads')}>
                  <div className="text-3xl font-bold mb-1 text-sahi-orange">{hotLeadsCount}</div>
                  <div className="text-[14px] font-medium text-gray-600">Hot Leads</div>
                </div>
                <div className="bg-bg-white rounded-xl py-4 md:border md:border-sahi-border-color md:shadow-md text-center cursor-pointer hover:bg-gray-50" onClick={() => handleMetricClick('Cold Contacts')}>
                  <div className="text-3xl font-bold mb-1 text-sahi-dark-blue">{coldContactsCount} <span className="text-xl text-sahi-red">({coldContactsData.dueTodayCount})</span></div>
                  <div className="text-[14px] font-medium text-gray-600">Cold Contacts</div>
                </div>
              </div>
            )} */}

            {/* 2. Details Pending - IF count > 0, it pushes things down. IF 0, things move UP */}

            <SalesPerformanceGauge
              actualAmount={premiumMetrics.orderValues}
              actualCount={premiumMetrics.orderCounts}
              lastMonthOrders={last3MonthsOrders[1] || { value: 0, count: 0 }}
              expectedValue={calculateExpectedPipeline()}
              countryID={agencyData?.CountryID}
              target={target}
              setTarget={setTarget}
              isAdmin={isAdmin}
            />

            <div className="w-full">
              {!isAdmin || cntMaxUsers == 1 ? (
                <OrderHistoryLeaderboard
                  last3MonthsOrders={last3MonthsOrders}
                  currencySymbol={currencySymbol}
                  countryID={agencyData.CountryID}
                  onThreadEntryOpen={handleThreadEntryOpen}
                  userRights={userRights}
                />
              ) : (
                <div className="space-y-4">
                  {isInqOnly && <ProductLeaderboard />}
                </div>
              )}
            </div>
            <div className="flex gap-2">
              <Button onClick={() => handleFeedbackOpen(1)} variant="secondary" className="!border-sahi-red !text-sahi-red hover:bg-sahi-red hover:!text-white h-10 text-sm px-3 flex-1 sm:flex-none">
                <AlertTriangle className="h-3.5 w-3.5 mr-1" /> Report Bug
              </Button>
              <Button onClick={() => handleFeedbackOpen(2)} variant="secondary" className="hover:bg-sahi-green text-sahi-green border-sahi-green h-10 text-sm px-3 flex-1 sm:flex-none">
                <Lightbulb className="h-3.5 w-3.5 mr-1" /> Share Idea
              </Button>
              <div className="gap-2 justify-between hidden sm:flex">
                {isInqOnlyMode && <div>
                  <QuickTraining
                    trainingData={getTrainingData("TRAINING1")}
                  />
                </div>}
              </div>
            </div>

          </div>
        </div>

      </div>
      </div>

      {/* Enhanced Right Sidebar - Tasks (Desktop Only) */}
      <div data-tour="inq-signup-tasks" className="lg:sticky lg:top-0 lg:h-screen lg:overflow-y-auto">
        <Tasks processedData={tasksData} threadData={threadData} onTaskEntryOpen={handleTaskEntryOpen} onRepeatTaskEntryOpen={handleRepeatTaskEntryOpen} showInquiries={false} />
      </div>


      {/* Dialogs - Desktop */}
      <TaskEntry
        triggerButton={false}
        open={isTaskEntryOpen}
        onOpenChange={(open) => { setIsTaskEntryOpen(open); if (!open) setTaskEntryPrefillData(null); }}
        prefilledData={taskEntryPrefillData}
      />

      <ConnectionEntryDialog
        triggerButton={false}
        open={isConnectionEntryOpen}
        onOpenChange={setIsConnectionEntryOpen}
        initialConnType={currentConnType}
      />

      {selectedConnection && (
        <ConnectionDetailsWrapper
          isOpen={isDetailOpen}
          onClose={handleDetailClose}
          connID={selectedConnection.connID}
        />
      )}

      <ThreadEntry
        triggerButton={false}
        open={isThreadEntryOpen}
        onOpenChange={setIsThreadEntryOpen}
        threadTypeID={currentThreadTypeID}
        calledFrom={(isInqOnly && currentThreadTypeID == 2) ? "ORDDONE" : ""}
      />

      {/* Feedback Dialog */}
      <TktDialog
        isOpen={isFeedbackOpen}
        onClose={handleFeedbackClose}
        selectedFeedbackType={selectedFeedbackType}
      />

      {/* Contract dialog */}
      <ContractEntry
        isOpen={isContractEntryOpen}
        onClose={setIsContractEntryOpen}
        prefilledData={{ contractTypeSelection: currentContractType }}
      />
      {/* Contract dialog */}
      <UpgradeSubscription open={upgradeOpen} onClose={setIsUpgradeOpen} />

      {/* Thread Stages Modal */}
      {isThreadStagesModalOpen && (
        <MastersDialog
          open={isThreadStagesModalOpen}
          onClose={() => setIsThreadStagesModalOpen(false)}
          masterType="threadStages"
          openEntry={false}
          directAdd={false}
        />
      )}

      <ImpDialog
        open={importDialogOpen}
        onOpenChange={setImportDialogOpen}
      />

      <RecordHistoryDialog
        isOpen={recordHistoryOpen}
        onClose={() => {
          setRecordHistoryOpen(false);
          setRecordHistoryFilter(null);
          setPendingRecordsData([]);
        }}
        threadData={threadData}
        threadTypes={threadTypes}
        records={pendingRecordsData}
        getExecutiveName={(uid) => {
          const user = userData.find(u => u.UserID === uid);
          return user ? user.Name : "Unknown";
        }}
        getRelativeDateText={(date) => {
          if (!date) return "N/A";
          return new Date(date).toLocaleDateString();
        }}
        onRecordEntryOpen={() => { }}
        connectionName="Details Pending"
        users={userData}
        connID={null}
        connIDs={pendingRecordsData.map(r => r.ConnID)}
        onRefreshRecords={handleRefreshPendingRecords}
        recordTypeFilter={recordHistoryFilter}
        connectionData={connectionData}
        isDashboardCall={true}
      />

      {/* Inactive Contact Breakdown Dialog - Desktop */}
      <Dialog open={inactiveDialogOpen} onOpenChange={setInactiveDialogOpen}>
        <DialogContent className="sm:max-w-[400px] bg-white p-0 gap-0">
          <DialogHeader className="border-b px-4 py-3">
            <div className="flex items-center justify-between w-full">
              <DialogTitle
                className="text-xl cursor-pointer hover:text-sahi-dark-blue transition-colors"
                onClick={() => {
                  navigate('/growth?tab=contacts&s=I');
                  setInactiveDialogOpen(false);
                }}
              >
                Inactive Customers
              </DialogTitle>
              <DialogClose asChild>
                <Button variant="ghost" className="h-8 w-8 p-0">
                  <X className="h-4 w-4" />
                </Button>
              </DialogClose>
            </div>
          </DialogHeader>
          <div className="p-4">
            <div className="grid grid-cols-3 gap-3">
              {/* 1. Unknown - Lightest shade of sahi-red */}
              <div
                className="flex flex-col items-start justify-between gap-[10px] p-3 rounded-[7px] bg-[#0D1F2D08] border border-[#0D1F2D20] hover:border-[#0D1F2D40] cursor-pointer transition-all duration-200"
                onClick={() => {
                  navigate(`/growth?tab=contacts&na=0`);
                  setInactiveDialogOpen(false);
                }}
              >
                <div className="flex items-center justify-between w-full">
                  <div className="flex items-center justify-center w-[24px] h-[24px] rounded-[5px] bg-[#A82224]">
                    <HelpCircle className="h-3.5 w-3.5 text-white" strokeWidth={1.8} />
                  </div>
                  <span className="text-[16px] font-semibold text-[#A82224]">
                    {inactiveStats.countUnknown}
                  </span>
                </div>
                <span className="text-[12px] min-[350px]:text-[12px] font-semibold text-[#0D1F2D]">Unknown</span>
              </div>

              {/* 2. Since 30D / Since 30 days - Base sahi-red */}
              <div
                className="flex flex-col items-start justify-between gap-[10px] p-3 rounded-[7px] bg-[#0D1F2D08] border border-[#0D1F2D20] hover:border-[#0D1F2D40] cursor-pointer transition-all duration-200"
                onClick={() => {
                  navigate(`/growth?tab=contacts&na=2`);
                  setInactiveDialogOpen(false);
                }}
              >
                <div className="flex items-center justify-between w-full">
                  <div className="flex items-center justify-center w-[24px] h-[24px] rounded-[5px] bg-sahi-red">
                    <Clock className="h-3.5 w-3.5 text-white" strokeWidth={1.8} />
                  </div>
                  <span className="text-[16px] font-semibold text-sahi-red">
                    {inactiveStats.count30}
                  </span>
                </div>
                <span className="text-[12px] min-[350px]:text-[12px] font-semibold text-[#0D1F2D] whitespace-nowrap">
                  <span className="max-[349px]:inline hidden">Since 30D</span>
                  <span className="min-[350px]:inline hidden">Since 30 days</span>
                </span>
              </div>

              {/* 3. Since 90D / Since 90 days - Darkest shade of sahi-red */}
              <div
                className="flex flex-col items-start justify-between gap-[10px] p-3 rounded-[7px] bg-[#0D1F2D08] border border-[#0D1F2D20] hover:border-[#0D1F2D40] cursor-pointer transition-all duration-200"
                onClick={() => {
                  navigate(`/growth?tab=contacts&na=4`);
                  setInactiveDialogOpen(false);
                }}
              >
                <div className="flex items-center justify-between w-full">
                  <div className="flex items-center justify-center w-[24px] h-[24px] rounded-[5px] bg-[#5B0C0D]">
                    <History className="h-3.5 w-3.5 text-white" strokeWidth={1.8} />
                  </div>
                  <span className="text-[16px] font-semibold text-[#5B0C0D]">
                    {inactiveStats.count90}
                  </span>
                </div>
                <span className="text-[12px] min-[350px]:text-[12px] font-semibold text-[#0D1F2D] whitespace-nowrap">
                  <span className="max-[349px]:inline hidden">Since 90D</span>
                  <span className="min-[350px]:inline hidden">Since 90 days</span>
                </span>
              </div>
            </div>
          </div>
          <div className="px-4 pb-4 flex justify-start">
            <Button variant="outline" onClick={() => setInactiveDialogOpen(false)} className="sahi-secondary-button flex-1 sm:flex-none sm:min-w-[100px]">
              <X className="h-4 w-4" /> Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default InqDashboard;
